import React, { useState, useEffect, useRef } from 'react'
import { ALL_QUESTIONS } from './questions'
import { LESSON_QUIZZES } from './quizzes'
import { MOCK_TESTS } from './mocks'
import { supabase } from './supabase'
import './App.css'
import { scoreQuestion, isFullyCorrect } from './scoring'

const PAGES = {
  LANDING:    '/',
  YUKSELISH_HUB: '/yukselish',
  YUKSELISH:  '/analitik-tehlil',
  YUKSELISH_IDAREETME: '/idareetme-bacariqlari',
  COURSE:     '/proqram',
  LESSON:     '/ders',
  AUTH:       '/daxil-ol',
  RESET:      '/sifre-yenile',
  DASHBOARD:  '/kabinet',
  TEST:       '/imtahan',
  RESULTS:    '/netice',
  CONTACT:    '/elaqe',
  TERMS:      '/qaydalar',
  PRIVACY:    '/gizlilik',
  HAQQIMIZDA: '/haqqimizda',
  FAQ:        '/suallar',
}

const TOPICS = {
  verbal:   { label: 'Verbal Təhlil',   icon: 'verbal',   desc: 'Oxuyub-anlama · Boşluq doldurma · Məntiqi nəticə çıxarma' },
  reqemsal: { label: 'Rəqəmsal Təhlil', icon: 'reqemsal', desc: 'Cədvəl və diaqramlar · Faiz hesablamaları · Statistik məlumatların təhlili' },
  abstrakt: { label: 'Abstrakt Təhlil', icon: 'abstrakt', desc: 'Fiqur ardıcıllığı · Vizual qanunauyğunluqlar · Məntiqi düşünmə' },
}

const EXAMS = [
  { key: 'yukselish',     name: 'Yüksəliş',       desc: 'Liderlik və idarəetmə müsabiqəsi',                   active: true  },
  { key: 'dovletqullugu', name: 'Dövlət Qulluğu', desc: 'Dövlət qulluğuna qəbul imtahanı · A, B, C növü',     active: false },
  { key: 'bakalavriat',   name: 'Bakalavriat',    desc: 'Ali məktəbə qəbul imtahanı · I-IV ixtisas qrupları', active: false },
  { key: 'magistratura',  name: 'Magistratura',   desc: 'Magistraturaya qəbul imtahanı · Bakalavrlar üçün',   active: false },
]

// ─── ICONS ────────────────────────────────────────────────────────────────────

function TopicIcon({ name, size = 28 }) {
  const s = size, bg = '#e8f3ff', c = '#0a74da', cl = '#3d97f5'
  const r = Math.round(size * 0.36)
  if (name === 'verbal') return (
    <svg width={s} height={s} viewBox="0 0 28 28" fill="none">
      <rect width="28" height="28" rx={r} fill={bg}/>
      <rect x="7" y="9" width="14" height="2.5" rx="1.25" fill={c}/>
      <rect x="7" y="13" width="10" height="2.5" rx="1.25" fill={c}/>
      <rect x="7" y="17" width="12" height="2.5" rx="1.25" fill={cl}/>
    </svg>
  )
  if (name === 'reqemsal') return (
    <svg width={s} height={s} viewBox="0 0 28 28" fill="none">
      <rect width="28" height="28" rx={r} fill={bg}/>
      <rect x="6" y="18" width="5" height="6" rx="1.5" fill={cl}/>
      <rect x="12" y="13" width="5" height="11" rx="1.5" fill={c}/>
      <rect x="18" y="8" width="5" height="16" rx="1.5" fill={c}/>
    </svg>
  )
  if (name === 'abstrakt') return (
    <svg width={s} height={s} viewBox="0 0 28 28" fill="none">
      <rect width="28" height="28" rx={r} fill={bg}/>
      <circle cx="14" cy="8" r="3.5" fill={c}/>
      <circle cx="7" cy="20" r="3.5" fill={c}/>
      <circle cx="21" cy="20" r="3.5" fill={cl}/>
      <line x1="14" y1="11.5" x2="7" y2="16.5" stroke={c} strokeWidth="1.8" strokeLinecap="round"/>
      <line x1="14" y1="11.5" x2="21" y2="16.5" stroke={cl} strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  )
  if (name === 'bundle') return (
    <svg width={s} height={s} viewBox="0 0 28 28" fill="none">
      <rect width="28" height="28" rx={r} fill={c}/>
      <path d="M14 5 L16.5 11.5 L23 14 L16.5 16.5 L14 23 L11.5 16.5 L5 14 L11.5 11.5 Z" fill="white"/>
    </svg>
  )
  if (name === 'analitik') return (
    <svg width={s} height={s} viewBox="0 0 28 28" fill="none">
      <rect width="28" height="28" rx={r} fill={c}/>
      <circle cx="13.5" cy="12.5" r="6.4" fill="none" stroke="white" strokeWidth="2"/>
      <rect x="17.4" y="16.3" width="2.6" height="7" rx="1.3" transform="rotate(-45 18.7 19.8)" fill="white"/>
      <rect x="10" y="12.5" width="2" height="3.4" rx="1" fill="white"/>
      <rect x="12.6" y="10" width="2" height="5.9" rx="1" fill="white"/>
      <rect x="15.2" y="8" width="2" height="7.9" rx="1" fill="white"/>
    </svg>
  )
  if (name === 'idareetme') return (
    <svg width={s} height={s} viewBox="0 0 28 28" fill="none">
      <rect width="28" height="28" rx={r} fill={c}/>
      <circle cx="5.5" cy="11" r="3" fill="white" opacity="0.8"/>
      <path d="M1 23 C1 18.8 3 17 5.5 17 C8 17 10 18.8 10 23 Z" fill="white" opacity="0.8"/>
      <circle cx="22.5" cy="11" r="3" fill="white" opacity="0.8"/>
      <path d="M18 23 C18 18.8 20 17 22.5 17 C25 17 27 18.8 27 23 Z" fill="white" opacity="0.8"/>
      <circle cx="14" cy="8" r="4" fill="white"/>
      <path d="M7 24 C7 17.8 10 15 14 15 C18 15 21 17.8 21 24 Z" fill="white"/>
    </svg>
  )
  if (name === 'keysler') return (
    <svg width={s} height={s} viewBox="0 0 28 28" fill="none">
      <rect width="28" height="28" rx={r} fill="#9ca3af"/>
      <path d="M5 9.5 A1.5 1.5 0 0 1 6.5 8 H11 L13 10 H21.5 A1.5 1.5 0 0 1 23 11.5 V20.5 A1.5 1.5 0 0 1 21.5 22 H6.5 A1.5 1.5 0 0 1 5 20.5 Z" fill="white"/>
    </svg>
  )
  if (name === 'smt') return (
    <svg width={s} height={s} viewBox="0 0 28 28" fill="none">
      <rect width="28" height="28" rx={r} fill={bg}/>
      <rect x="13" y="5" width="2.2" height="18" rx="1.1" fill={c}/>
      <path d="M5 8 H17.5 L20.5 11 L17.5 14 H5 Z" fill={c}/>
      <path d="M23 16 H10.5 L7.5 19 L10.5 22 H23 Z" fill={cl}/>
    </svg>
  )
  if (name === 'ez') return (
    <svg width={s} height={s} viewBox="0 0 28 28" fill="none">
      <rect width="28" height="28" rx={r} fill={bg}/>
      <path d="M4 5 H15 A2.4 2.4 0 0 1 17.4 7.4 V12 A2.4 2.4 0 0 1 15 14.4 H8.5 L5 17.5 V14.4 H4 A2.4 2.4 0 0 1 1.6 12 V7.4 A2.4 2.4 0 0 1 4 5 Z" fill={c}/>
      <path d="M13 13 H24 A2.4 2.4 0 0 1 26.4 15.4 V20 A2.4 2.4 0 0 1 24 22.4 H19.5 L16 25.5 V22.4 H13 A2.4 2.4 0 0 1 10.6 20 V15.4 A2.4 2.4 0 0 1 13 13 Z" fill={cl}/>
    </svg>
  )
  return null
}

function ExamIcon({ name, size = 22, color = '#0a74da' }) {
  const w = size
  const common = { width: w, height: w, viewBox: '0 0 24 24', fill: 'none', stroke: color, strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' }
  if (name === 'yukselish') return (
    <svg {...common}>
      <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/>
      <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/>
      <path d="M4 22h16"/>
      <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/>
      <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/>
      <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"/>
    </svg>
  )
  if (name === 'bakalavriat') return (
    <svg {...common}>
      <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
      <path d="M6 12v5c0 1.7 3 3 6 3s6-1.3 6-3v-5"/>
    </svg>
  )
  if (name === 'magistratura') return (
    <svg {...common}>
      <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
      <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
    </svg>
  )
  if (name === 'dovletqullugu') return (
    <svg {...common}>
      <line x1="3" y1="21" x2="21" y2="21"/>
      <line x1="3" y1="10" x2="21" y2="10"/>
      <polyline points="5 6 12 3 19 6"/>
      <line x1="4" y1="10" x2="4" y2="21"/>
      <line x1="20" y1="10" x2="20" y2="21"/>
      <line x1="8" y1="14" x2="8" y2="18"/>
      <line x1="12" y1="14" x2="12" y2="18"/>
      <line x1="16" y1="14" x2="16" y2="18"/>
    </svg>
  )
  return null
}

// ─── LOGO ─────────────────────────────────────────────────────────────────────

function Logo({ size = 'md', onClick }) {
  const lg = size === 'lg'
  const circleSize = lg ? 76 : 40
  const textSize   = lg ? 48 : 24
  const subSize    = lg ? 12 : 8

  return (
    <div
      style={{ display:'inline-flex', alignItems:'center', gap: lg ? 16 : 8, cursor: onClick ? 'pointer' : 'default', userSelect:'none' }}
      onClick={onClick}
    >
      <div style={{
        width: circleSize,
        height: circleSize,
        borderRadius: '50%',
        background: '#0a74da',
        overflow: 'hidden',
        position: 'relative',
        flexShrink: 0,
      }}>
        <svg
          width={circleSize}
          height={circleSize}
          viewBox="0 0 52 52"
          style={{ display: 'block' }}
        >
          <g transform="rotate(15,26,26)">
            <rect x="13" y="2"  width="6"  height="48" rx="3"   fill="white"/>
            <rect x="33" y="2"  width="6"  height="48" rx="3"   fill="white"/>
            <rect x="13" y="8"  width="26" height="5"  rx="2.5" fill="white"/>
            <rect x="13" y="21" width="26" height="5"  rx="2.5" fill="white"/>
            <rect x="13" y="34" width="26" height="5"  rx="2.5" fill="white"/>
          </g>
        </svg>
      </div>
      <div style={{ display:'flex', flexDirection:'column', gap: lg ? 6 : 3, alignItems: 'flex-start' }}>
        <span style={{ fontFamily: "'Inter','Segoe UI',system-ui,sans-serif", fontSize: textSize, fontWeight: 700, letterSpacing: lg ? -2 : -1, color: '#0958a8', lineHeight: 1, whiteSpace: 'nowrap', marginLeft: lg ? '-3px' : '-1px', display: 'block' }}>pillə</span>
        <span style={{ fontFamily: "'Inter','Segoe UI',system-ui,sans-serif", fontSize: subSize, fontWeight: 600, letterSpacing: lg ? 3 : 2, color: '#0a74da', textTransform: 'uppercase', whiteSpace: 'nowrap', display: 'block' }}>təhsil platforması</span>
      </div>
    </div>
  )
}

// ─── useIsMobile hook ─────────────────────────────────────────────────────────

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth < breakpoint : false)
  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < breakpoint)
    check()
    window.addEventListener('resize', check)
    return () => window.removeEventListener('resize', check)
  }, [breakpoint])
  return isMobile
}

// ─── APP ──────────────────────────────────────────────────────────────────────

export default function App() {
  const [page, setPage] = useState(PAGES.LANDING)
  const [user, setUser] = useState(null)
  const [purchases, setPurchases] = useState([])
  const [authInitialMode, setAuthInitialMode] = useState('login')
  const [testState, setTestState] = useState(() => {
    try {
      const saved = sessionStorage.getItem('pille_testState')
      return saved ? JSON.parse(saved) : null
    } catch { return null }
  })
  const [results, setResults] = useState(() => {
    try {
      const saved = sessionStorage.getItem('pille_results')
      return saved ? JSON.parse(saved) : null
    } catch { return null }
  })
  const [loading, setLoading] = useState(true)
  const [currentCourse, setCurrentCourse] = useState(() => {
    try { return sessionStorage.getItem('pille_course') || null } catch { return null }
  })
  const [currentLesson, setCurrentLesson] = useState(() => {
    try { const s = sessionStorage.getItem('pille_lesson'); return s ? JSON.parse(s) : null } catch { return null }
  })

  useEffect(() => {
    try {
      if (currentCourse) sessionStorage.setItem('pille_course', currentCourse)
      else sessionStorage.removeItem('pille_course')
    } catch {}
  }, [currentCourse])

  useEffect(() => {
    try {
      if (currentLesson) sessionStorage.setItem('pille_lesson', JSON.stringify(currentLesson))
      else sessionStorage.removeItem('pille_lesson')
    } catch {}
  }, [currentLesson])

  useEffect(() => {
    try {
      if (testState) sessionStorage.setItem('pille_testState', JSON.stringify(testState))
      else sessionStorage.removeItem('pille_testState')
    } catch {}
  }, [testState])

  useEffect(() => {
    try {
      if (results) sessionStorage.setItem('pille_results', JSON.stringify(results))
      else sessionStorage.removeItem('pille_results')
    } catch {}
  }, [results])

  const navigate = (newPage) => {
    window.history.pushState({ page: newPage }, '', newPage)
    setPage(newPage)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  useEffect(() => {
    const pathname = window.location.pathname
    const validPages = Object.values(PAGES)
    const courseFromPath = pathname.startsWith(PAGES.COURSE + '/')
      ? decodeURIComponent(pathname.slice((PAGES.COURSE + '/').length))
      : ''
    const lessonParts = pathname.startsWith(PAGES.LESSON + '/')
      ? pathname.slice((PAGES.LESSON + '/').length).split('/').filter(Boolean).map(decodeURIComponent)
      : null
    let initialPage = validPages.includes(pathname) ? pathname : PAGES.LANDING
    if (courseFromPath) { setCurrentCourse(courseFromPath); initialPage = PAGES.COURSE }
    if (lessonParts && lessonParts.length >= 2) {
      const lc = lessonParts[0]; const ln = parseInt(lessonParts[1], 10)
      setCurrentCourse(lc)
      initialPage = PAGES.LESSON
      ;(async () => {
        try {
          const { data } = await supabase.from('lessons').select('*')
            .eq('course', lc).eq('lesson_number', ln).maybeSingle()
          if (data) setCurrentLesson(data)
        } catch {}
      })()
    }
    const hasResults = !!sessionStorage.getItem('pille_results')
    const hasTestState = !!sessionStorage.getItem('pille_testState')
    if (initialPage === PAGES.RESULTS && !hasResults) initialPage = PAGES.LANDING
    if (initialPage === PAGES.TEST && !hasTestState) initialPage = PAGES.LANDING
    if (initialPage === PAGES.COURSE && !sessionStorage.getItem('pille_course') && !courseFromPath) initialPage = PAGES.YUKSELISH_HUB
    if (initialPage === PAGES.LESSON && !lessonParts && !sessionStorage.getItem('pille_lesson')) initialPage = PAGES.YUKSELISH_HUB
    setPage(initialPage)
    // Preserve hash on initial load (Supabase needs it for recovery tokens)
    if (lessonParts && initialPage === PAGES.LESSON) {
      window.history.replaceState({ page: PAGES.LESSON, course: lessonParts[0], lessonNumber: parseInt(lessonParts[1], 10) }, '', pathname)
    } else if (courseFromPath && initialPage === PAGES.COURSE) {
      window.history.replaceState({ page: PAGES.COURSE, course: courseFromPath }, '', pathname)
    } else if (initialPage !== pathname) {
      window.history.replaceState({ page: initialPage }, '', initialPage)
    } else {
      window.history.replaceState({ page: initialPage }, '')
    }

    const handlePop = (e) => {
      const st = e.state || {}
      const p = st.page || PAGES.LANDING
      if (st.course) setCurrentCourse(st.course)
      if (p === PAGES.LESSON && st.course && st.lessonNumber) {
        ;(async () => {
          try {
            const { data } = await supabase.from('lessons').select('*')
              .eq('course', st.course).eq('lesson_number', st.lessonNumber).maybeSingle()
            if (data) setCurrentLesson(data)
          } catch {}
        })()
      }
      setPage(p)
    }
    window.addEventListener('popstate', handlePop)
    return () => window.removeEventListener('popstate', handlePop)
  }, [])

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const payment = params.get('payment')
    if (payment === 'success') {
      window.history.replaceState({}, '', window.location.pathname)
      let tries = 0
      const interval = setInterval(async () => {
        tries++
        if (user) await loadPurchases(user.id)
        if (tries >= 5) { clearInterval(interval); alert('✓ Ödəniş uğurla tamamlandı! Bölmə aktivləşdi.') }
      }, 1500)
    } else if (payment === 'cancel') {
      window.history.replaceState({}, '', window.location.pathname)
      alert('Ödəniş ləğv edildi.')
    }
  }, [user?.id])

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null)
      if (session?.user) loadPurchases(session.user.id)
      setLoading(false)
    })
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_e, session) => {
      setUser(session?.user ?? null)
      if (session?.user) loadPurchases(session.user.id)
    })
    return () => subscription.unsubscribe()
  }, [])

  const loadPurchases = async (uid) => {
    const { data } = await supabase.from('purchases').select('topic').eq('user_id', uid)
    setPurchases(data?.map(p => p.topic) || [])
  }

  // TEMP REVIEW SWITCH: while true, all İdarəetmə tests (SMT + EZ mocks and quizzes)
  // are OPEN to everyone, no purchase needed. Set to false to put them back behind
  // the paywall before you start charging. This only affects İdarəetmə, not the
  // verbal/numerical/abstract blocks.
  const UNLOCK_IDAREETME = false

  const hasPurchased = (topic) => {
    if (UNLOCK_IDAREETME && ['smt', 'ez', 'idareetme'].includes(topic)) return true
    if (purchases.includes(topic)) return true
    if (purchases.includes('bundle') && ['verbal','reqemsal','abstrakt'].includes(topic)) return true
    if (purchases.includes('idareetme') && ['smt','ez'].includes(topic)) return true
    return false
  }

  const handleBuy = async (topic) => {
    if (!user) { goToAuth('register'); return }
    if (hasPurchased(topic)) {
      navigate(PAGES.DASHBOARD)
      return
    }
    try {
      const res = await fetch('/api/create-checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ topic, userId: user.id, userEmail: user.email }),
      })
      const data = await res.json()
      if (data.url) window.location.href = data.url
      else alert('Ödəniş başlanmadı: ' + (data.error || 'xəta'))
    } catch (err) {
      alert('Şəbəkə xətası: ' + err.message)
    }
  }

  const startTest = (topic, testNum = 0) => {
    if (topic === 'mix') {
      const v = ALL_QUESTIONS.filter(q => q.topic === 'verbal'   && q.is_free)
      const r = ALL_QUESTIONS.filter(q => q.topic === 'reqemsal' && q.is_free)
      const a = ALL_QUESTIONS.filter(q => q.topic === 'abstrakt' && q.is_free)
      const qs = [...v, ...r, ...a]
      if (qs.length === 0) { alert('Nümunə suallar tapılmadı!'); return }
      setTestState({ topic: 'mix', testNum: 0, questions: qs, answers: {}, current: 0, startTime: Date.now(), pendingStart: true, showingTransition: false })
      navigate(PAGES.TEST)
      return
    }

    const allQs = ALL_QUESTIONS.filter(q => q.topic === topic)
    if (allQs.length === 0) { alert('Bu bölmə tezliklə əlavə ediləcək!'); return }
    let qs
    if (testNum === 0 || !hasPurchased(topic)) {
      qs = allQs.filter(q => q.is_free)
    } else {
      qs = allQs.filter(q => q.test_num === (testNum || 1))
    }
    if (qs.length === 0) { alert('Bu test tapılmadı!'); return }
    setTestState({ topic, testNum: (testNum === 0 || !hasPurchased(topic)) ? 0 : (testNum || 1), questions: qs, answers: {}, current: 0, startTime: Date.now(), pendingStart: true })
    navigate(PAGES.TEST)
  }

  const ALL_QUIZZES = [...LESSON_QUIZZES]
  const startQuiz = (course, lessonNumber) => {
    const qs = ALL_QUIZZES.filter(q => q.course === course && q.lesson_number === lessonNumber)
    if (qs.length === 0) { alert('Bu dərsin quizi tezliklə əlavə olunacaq.'); return }
    const isFreeLesson = qs.every(q => q.is_free)
    if (!isFreeLesson && !hasPurchased(course)) {
      if (!user) { goToAuth('register'); return }
      handleBuy(course); return
    }
    const courseNames = { smt: 'Situasiya Mühakiməsi', ez: 'Emosional Zəka' }
    const quizLabel = courseNames[course] || course
    setTestState({ topic: course + '-l' + lessonNumber, testNum: 0, questions: qs, answers: {}, current: 0, startTime: Date.now(), pendingStart: true, isQuiz: true, quizCourse: course, quizLesson: lessonNumber, quizLabel })
    navigate(PAGES.TEST)
  }

  const startMock = (course, mockNum) => {
    const qs = MOCK_TESTS.filter(q => q.course === course && q.mock_num === mockNum)
    if (qs.length === 0) { alert('Bu test tezliklə əlavə olunacaq.'); return }
    if (!hasPurchased(course)) {
      if (!user) { goToAuth('register'); return }
      handleBuy(course); return
    }
    const courseNames = { smt: 'Situasiya Mühakiməsi', ez: 'Emosional Zəka' }
    const quizLabel = courseNames[course] || course
    setTestState({ topic: course + '-m' + mockNum, testNum: 0, questions: qs, answers: {}, current: 0, startTime: Date.now(), pendingStart: true, isQuiz: true, quizCourse: course, quizMock: mockNum, quizLabel })
    navigate(PAGES.TEST)
  }

  const finishTest = (answers, hintsUsed = 0) => {
    const qs = testState.questions
    let score = 0, maxScore = 0
    qs.forEach(q => { maxScore += q.points; score += scoreQuestion(q, answers[q.id]) })
    const timeSpent = Math.floor((Date.now() - testState.startTime) / 1000)
    setResults({ questions: qs, answers, score, maxScore, timeSpent, topic: testState.topic, testNum: testState.testNum, hintsUsed, label: testState.quizLabel, isQuiz: !!testState.isQuiz, quizCourse: testState.quizCourse, quizLesson: testState.quizLesson, quizMock: testState.quizMock })
    navigate(PAGES.RESULTS)
  }

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: '#0a74da', fontSize: '16px', fontWeight: 500 }}>
      Yüklənir...
    </div>
  )

  const navTo = (p) => navigate(p)
  const goToAuth = (mode) => {
    setAuthInitialMode(typeof mode === 'string' ? mode : 'login')
    navigate(PAGES.AUTH)
  }
  const goToCourse = (slug) => {
    setCurrentCourse(slug)
    setPage(PAGES.COURSE)
    window.history.pushState({ page: PAGES.COURSE, course: slug }, '', `${PAGES.COURSE}/${slug}`)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
  const goToLesson = (lesson) => {
    setCurrentCourse(lesson.course)
    setCurrentLesson(lesson)
    setPage(PAGES.LESSON)
    window.history.pushState({ page: PAGES.LESSON, course: lesson.course, lessonNumber: lesson.lesson_number }, '', `${PAGES.LESSON}/${lesson.course}/${lesson.lesson_number}`)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
  const openLesson = async (course, lessonNumber) => {
    try {
      const { data } = await supabase.from('lessons').select('*')
        .eq('course', course).eq('lesson_number', lessonNumber).maybeSingle()
      if (data && (data.is_free || hasPurchased(course))) { goToLesson(data) }
      else { goToCourse(course) }
    } catch { goToCourse(course) }
  }
  const showFooter = ![PAGES.TEST, PAGES.AUTH].includes(page)

  return (
    <div className="app">
      {page === PAGES.LANDING    && <Landing    user={user} onAuth={goToAuth} onYukselish={() => navigate(PAGES.YUKSELISH_HUB)} onDashboard={() => { loadPurchases(user?.id); navigate(PAGES.DASHBOARD) }} onNav={navTo} />}
      {page === PAGES.YUKSELISH_HUB && <YukselishHub user={user} onAuth={goToAuth} onHome={() => navigate(PAGES.LANDING)} onDashboard={() => { loadPurchases(user?.id); navigate(PAGES.DASHBOARD) }} onNav={navTo} onAnalitik={() => navigate(PAGES.YUKSELISH)} onIdareetme={() => navigate(PAGES.YUKSELISH_IDAREETME)} />}
      {page === PAGES.YUKSELISH_IDAREETME && <IdareetmePage user={user} purchases={purchases} hasPurchased={hasPurchased} onBuy={handleBuy} onCourse={goToCourse} onLesson={openLesson} onAuth={goToAuth} onHome={() => navigate(PAGES.LANDING)} onDashboard={() => { loadPurchases(user?.id); navigate(PAGES.DASHBOARD) }} onNav={navTo} onBack={() => navigate(PAGES.YUKSELISH_HUB)} />}
      {page === PAGES.YUKSELISH  && <Yukselish  user={user} purchases={purchases} hasPurchased={hasPurchased} onAuth={goToAuth} onHome={() => navigate(PAGES.LANDING)} onDashboard={() => { loadPurchases(user?.id); navigate(PAGES.DASHBOARD) }} onStart={startTest} onBuy={handleBuy} onNav={navTo} />}
      {page === PAGES.COURSE     && currentCourse && <CoursePage  user={user} courseSlug={currentCourse} purchases={purchases} hasPurchased={hasPurchased} onBuy={handleBuy} onMock={startMock} onAuth={goToAuth} onHome={() => navigate(PAGES.LANDING)} onDashboard={() => { loadPurchases(user?.id); navigate(PAGES.DASHBOARD) }} onNav={navTo} onBack={() => navigate(PAGES.YUKSELISH_IDAREETME)} onLesson={goToLesson} onCourse={goToCourse} />}
      {page === PAGES.LESSON     && currentLesson && <LessonPage  user={user} lesson={currentLesson} hasPurchased={hasPurchased} onBuy={handleBuy} onAuth={goToAuth} onHome={() => navigate(PAGES.LANDING)} onDashboard={() => { loadPurchases(user?.id); navigate(PAGES.DASHBOARD) }} onNav={navTo} onBack={() => goToCourse(currentCourse)} onQuiz={startQuiz} onLesson={goToLesson} />}
      {page === PAGES.AUTH       && <Auth onSuccess={(u) => { setUser(u); loadPurchases(u.id); navigate(PAGES.DASHBOARD) }} onBack={() => navigate(PAGES.LANDING)} initialMode={authInitialMode} />}
      {page === PAGES.RESET      && <PasswordResetPage onSuccess={() => navigate(PAGES.DASHBOARD)} onBack={() => navigate(PAGES.LANDING)} />}
      {page === PAGES.DASHBOARD  && <Dashboard  user={user} purchases={purchases} hasPurchased={hasPurchased} onStart={startTest} onBuy={handleBuy} onCourse={goToCourse} onHome={() => navigate(PAGES.LANDING)} onLogout={async () => { await supabase.auth.signOut(); setUser(null); setPurchases([]); setTestState(null); setResults(null); navigate(PAGES.LANDING) }} onNav={navTo} />}
      {page === PAGES.TEST       && testState && <TestScreen user={user} testState={testState} setTestState={setTestState} onFinish={finishTest} onExit={() => { if (testState?.isQuiz) { if (testState.quizLesson) openLesson(testState.quizCourse, testState.quizLesson); else goToCourse(testState.quizCourse) } else navigate(user ? PAGES.DASHBOARD : PAGES.YUKSELISH) }} onAuthSuccess={(u) => { setUser(u); loadPurchases(u.id) }} />}
      {page === PAGES.RESULTS    && results   && <Results results={results} onRetry={() => results.isQuiz ? (results.quizMock ? startMock(results.quizCourse, results.quizMock) : startQuiz(results.quizCourse, results.quizLesson)) : startTest(results.topic, results.testNum)} onSelectTest={(t) => startTest(results.topic, t)} onHome={() => navigate(user ? PAGES.DASHBOARD : PAGES.YUKSELISH)} onBackToCourse={() => goToCourse(results.quizCourse)} onBackToLesson={() => results.quizLesson ? openLesson(results.quizCourse, results.quizLesson) : goToCourse(results.quizCourse)} onNextLesson={() => openLesson(results.quizCourse, (results.quizLesson || 0) + 1)} hasPurchased={hasPurchased} onAuth={goToAuth} onBuy={handleBuy} user={user} />}
      {page === PAGES.CONTACT    && <ContactPage    onHome={() => navigate(PAGES.LANDING)} user={user} onNav={navTo} onDashboard={() => navigate(PAGES.DASHBOARD)} onAuth={goToAuth} />}
      {page === PAGES.TERMS      && <TermsPage      onHome={() => navigate(PAGES.LANDING)} user={user} />}
      {page === PAGES.PRIVACY    && <PrivacyPage    onHome={() => navigate(PAGES.LANDING)} user={user} />}
      {page === PAGES.HAQQIMIZDA && <HaqqimizdaPage onHome={() => navigate(PAGES.LANDING)} user={user} onNav={navTo} onDashboard={() => navigate(PAGES.DASHBOARD)} onAuth={goToAuth} />}
      {page === PAGES.FAQ        && <FaqPage onHome={() => navigate(PAGES.LANDING)} user={user} onNav={navTo} onDashboard={() => navigate(PAGES.DASHBOARD)} onAuth={goToAuth} />}
      {showFooter && <Footer navTo={navTo} />}
      <div style={{position:'fixed', bottom:'6px', right:'8px', fontSize:'10px', color:'#9ca3af', background:'rgba(255,255,255,0.75)', padding:'2px 7px', borderRadius:'6px', zIndex:99999, pointerEvents:'none', fontFamily:'monospace'}}>build: nav+list v2</div>
    </div>
  )
}

// ─── SHARED NAV HEADER (with mobile hamburger) ─────────────────────────────

function SiteNav({ user, onLogo, onNav, onAuth, onDashboard, currentPage, extraLinks = [] }) {
  const isMobile = useIsMobile()
  const [menuOpen, setMenuOpen] = useState(false)

  const navItems = [
    { key: 'imtahanlar', label: 'İmtahanlar', onClick: () => {
        setMenuOpen(false)
        if (currentPage === PAGES.LANDING) {
          document.getElementById('exams-section')?.scrollIntoView({behavior:'smooth'})
        } else {
          onNav(PAGES.LANDING)
          setTimeout(() => document.getElementById('exams-section')?.scrollIntoView({behavior:'smooth'}), 100)
        }
    }},
    { key: 'haqqimizda', label: 'Haqqımızda', onClick: () => { setMenuOpen(false); onNav(PAGES.HAQQIMIZDA) }},
    { key: 'elaqe',      label: 'Əlaqə',      onClick: () => { setMenuOpen(false); onNav(PAGES.CONTACT) }},
  ]

  const authBlock = user ? (
    <button className="btn-primary" onClick={() => { setMenuOpen(false); onDashboard() }}>Kabinetə keç</button>
  ) : (
    <>
      <button className="btn-ghost"   onClick={() => { setMenuOpen(false); onAuth('login') }}>Daxil ol</button>
      <button className="btn-primary" onClick={() => { setMenuOpen(false); onAuth('register') }}>Qeydiyyat</button>
    </>
  )

  return (
    <nav className="nav" style={{position:'relative'}}>
      <Logo onClick={onLogo} />

      {!isMobile && (
        <>
          <div className="nav-links">
            {extraLinks.map(l => (
              <span key={l.key} style={{cursor:'pointer'}} onClick={l.onClick}>{l.label}</span>
            ))}
            {navItems.map(item => (
              <span key={item.key} style={{cursor:'pointer'}} onClick={item.onClick}>{item.label}</span>
            ))}
          </div>
          <div className="nav-actions">{authBlock}</div>
        </>
      )}

      {isMobile && (
        <button
          onClick={() => setMenuOpen(v => !v)}
          aria-label="Menyu"
          style={{
            background: menuOpen ? '#f0f7ff' : 'transparent',
            border: '1px solid #d1e4f7',
            borderRadius: '8px',
            width: '40px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            padding: 0,
          }}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0a74da" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            {menuOpen
              ? (<><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>)
              : (<><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></>)}
          </svg>
        </button>
      )}

      {isMobile && menuOpen && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          background: 'white',
          borderTop: '1px solid #e5e7eb',
          borderBottom: '1px solid #e5e7eb',
          boxShadow: '0 6px 14px rgba(0,0,0,0.06)',
          padding: '8px 24px 20px',
          zIndex: 100,
        }}>
          {extraLinks.map(l => (
            <div key={l.key} onClick={l.onClick}
              style={{fontSize:'15px', color:'#0c1f4a', padding:'14px 4px', borderBottom:'1px solid #f3f4f6', cursor:'pointer', fontWeight:500}}>
              {l.label}
            </div>
          ))}
          {navItems.map(item => (
            <div key={item.key} onClick={item.onClick}
              style={{fontSize:'15px', color:'#0c1f4a', padding:'14px 4px', borderBottom:'1px solid #f3f4f6', cursor:'pointer', fontWeight:500}}>
              {item.label}
            </div>
          ))}
          <div style={{display:'flex', gap:'8px', marginTop:'14px'}}>
            {user ? (
              <button className="btn-primary" style={{flex:1}} onClick={() => { setMenuOpen(false); onDashboard() }}>Kabinetə keç</button>
            ) : (
              <>
                <button className="btn-ghost"   style={{flex:1}} onClick={() => { setMenuOpen(false); onAuth('login') }}>Daxil ol</button>
                <button className="btn-primary" style={{flex:1}} onClick={() => { setMenuOpen(false); onAuth('register') }}>Qeydiyyat</button>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  )
}

// ─── LANDING (general 4-exam platform) ────────────────────────────────────────

function Landing({ user, onAuth, onYukselish, onDashboard, onNav }) {
  return (
    <div className="landing">
      <SiteNav
        user={user}
        onLogo={() => window.scrollTo({top:0,behavior:'smooth'})}
        onNav={onNav}
        onAuth={onAuth}
        onDashboard={onDashboard}
        currentPage={PAGES.LANDING}
      />

      <div className="hero" style={{paddingBottom:'40px'}}>
        <div style={{display:'flex', justifyContent:'center', marginBottom:'28px'}}>
          <Logo size="lg" />
        </div>
        <h1 className="hero-tagline" style={{marginTop:'32px'}}>
          Bütün imtahanlar.<br/><span style={{color:'#0a74da'}}>Bir platformada.</span>
        </h1>
        <p className="hero-desc" style={{marginBottom:0}}>
          Karyeranızın növbəti <span style={{color:'#0a74da', fontWeight:600}}>pilləsi</span>ni kəşf edin
        </p>
      </div>

      <div className="topics-section" id="exams-section" style={{paddingTop:'56px', paddingBottom:'72px'}}>
        <h2>Hansı <span style={{color:'#0a74da'}}>pillə</span>dəsiniz?</h2>
        <p className="section-sub" style={{fontSize:'15px'}}>İmtahanınızı seçin, hazırlığa indi başlayın</p>
        <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(260px, 1fr))', gap:'18px', maxWidth:'640px', margin:'0 auto'}}>
          {EXAMS.map(exam => (
            <ExamCard key={exam.key} exam={exam} onClick={exam.active ? onYukselish : null} />
          ))}
        </div>
      </div>
    </div>
  )
}

function ExamCard({ exam, onClick }) {
  const { name, desc, active } = exam
  const isYukselish = exam.key === 'yukselish'

  return (
    <div
      style={{
        background: active ? '#f0f7ff' : 'white',
        border: active ? '2px solid #0a74da' : '1.5px solid #d1e4f7',
        borderRadius: '14px',
        padding: '28px 22px',
        textAlign: 'center',
        position: 'relative',
        opacity: active ? 1 : 0.42,
        cursor: active && onClick ? 'pointer' : 'default',
        transition: 'transform 0.15s, box-shadow 0.15s',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        minHeight: '340px',
        height: '100%',
      }}
      onClick={active && onClick ? onClick : undefined}
      onMouseEnter={(e) => active && (e.currentTarget.style.transform = 'translateY(-2px)')}
      onMouseLeave={(e) => active && (e.currentTarget.style.transform = 'translateY(0)')}
    >
      {active && (
        <div style={{
          position: 'absolute', top: '-13px', left: '50%', transform: 'translateX(-50%)',
          background: '#0a74da', color: 'white', fontSize: '12px', fontWeight: 700,
          padding: '5px 16px', borderRadius: '20px', whiteSpace: 'nowrap', letterSpacing: '0.5px',
        }}>İndi mövcuddur</div>
      )}

      <div style={{
        width: '60px', height: '60px', borderRadius: '14px',
        background: active ? '#0a74da' : '#e8f3ff',
        margin: '0 auto 16px',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <ExamIcon name={exam.key} size={32} color={active ? 'white' : '#0a74da'} />
      </div>

      <div style={{fontSize:'22px', fontWeight:700, color:'#0c1f4a', marginBottom:'10px'}}>{name}</div>
      <div style={{fontSize:'15px', color:'#4b5563', lineHeight:1.55, marginBottom:'20px', minHeight:'48px'}}>{desc}</div>

      {active && isYukselish && (
        <>
          <div style={{flex: 1}}></div>
          <button
            className="btn-primary"
            style={{width:'100%', padding:'13px', fontSize:'16px', fontWeight:600}}
            onClick={(e) => { e.stopPropagation(); onClick && onClick() }}
          >
            Hazırlaşmağa başla →
          </button>
          <div style={{display:'flex', gap:'10px', borderTop:'1px solid #d1e4f7', marginTop:'18px', paddingTop:'18px'}}>
            <div style={{flex:1, textAlign:'center'}}>
              <div style={{fontSize:'24px', fontWeight:700, color:'#0958a8'}}>2</div>
              <div style={{fontSize:'13px', color:'#6b7280', marginTop:'2px'}}>Mərhələ</div>
            </div>
            <div style={{flex:1, textAlign:'center'}}>
              <div style={{fontSize:'24px', fontWeight:700, color:'#0958a8'}}>15</div>
              <div style={{fontSize:'13px', color:'#6b7280', marginTop:'2px'}}>Test</div>
            </div>
            <div style={{flex:1, textAlign:'center'}}>
              <div style={{fontSize:'24px', fontWeight:700, color:'#0958a8'}}>654</div>
              <div style={{fontSize:'13px', color:'#6b7280', marginTop:'2px'}}>Sual</div>
            </div>
          </div>
        </>
      )}

      {!active && (
        <>
          <div style={{flex: 1}}></div>
          <span style={{
            background:'#f3f4f6', color:'#9ca3af', fontSize:'13px', fontWeight:700,
            padding:'8px 20px', borderRadius:'20px', display:'inline-block', letterSpacing:'1.5px',
            alignSelf: 'center',
          }}>TEZLIKLƏ</span>
          <div style={{height:'76px'}}></div>
        </>
      )}
    </div>
  )
}

// ─── YÜKSƏLIŞ COURSE PAGE ─────────────────────────────────────────────────────

function Yukselish({ user, purchases, hasPurchased, onAuth, onHome, onDashboard, onStart, onBuy, onNav }) {
  const onBuyOrAuth = (topic) => user ? onBuy(topic) : onAuth()
  const ownsBundle = (purchases || []).includes('bundle')

  return (
    <div className="landing">
      <SiteNav
        user={user}
        onLogo={onHome}
        onNav={onNav}
        onAuth={onAuth}
        onDashboard={onDashboard}
        currentPage={PAGES.YUKSELISH}
      />

      <div style={{padding:'11px 28px', background:'#f9fbff', borderBottom:'1px solid #e5e7eb', fontSize:'13px', color:'#6b7280'}}>
        <span style={{cursor:'pointer', color:'#0a74da', fontWeight:500}} onClick={onHome}>← Bütün imtahanlar</span>
        <span style={{margin:'0 8px', color:'#d1d5db'}}>/</span>
        <span style={{color:'#0c1f4a', fontWeight:600}}>Yüksəliş</span>
      </div>

      <div className="hero" style={{paddingBottom:'56px'}}>
        <div style={{fontSize:'13px', fontWeight:700, color:'#0a74da', letterSpacing:'2px', textTransform:'uppercase', marginBottom:'18px'}}>YÜKSƏLIŞ MÜSABIQƏSI</div>
        <h1 className="hero-tagline">Analitik Təhlil<br/>imtahanına hazırlıq</h1>
        <p className="hero-desc" style={{maxWidth:'580px'}}>
          Verbal, Rəqəmsal və Abstrakt Təhlil üzrə peşəkar hazırlıq · Real imtahan formatı · Detallı izahlar
        </p>
        <div className="hero-btns">
          <button className="btn-primary btn-lg" onClick={() => onStart('mix', 0)}>Ödənişsiz başla</button>
        </div>
      </div>

      <div className="pricing-section" id="sections">
        <h2>Üç bölmə · Bir hazırlıq</h2>
        <p className="section-sub" style={{fontSize:'15px'}}>Hər bölmədə 3 tam test, 75 sual və 5 ödənişsiz nümunə</p>
        <div className="pricing-grid pricing-grid-4">
          {[
            { key:'verbal',   label:'Verbal Təhlil',   sub:'Oxuyub-anlama · Boşluq doldurma · Məntiqi nəticə çıxarma' },
            { key:'reqemsal', label:'Rəqəmsal Təhlil', sub:'Cədvəl və diaqramlar · Faiz hesablamaları · Statistik təhlil' },
            { key:'abstrakt', label:'Abstrakt Təhlil', sub:'Fiqur ardıcıllığı · Vizual qanunauyğunluqlar · Məntiqi düşünmə' },
          ].map(({ key, label, sub }) => {
            const owned = hasPurchased ? hasPurchased(key) : false
            return (
              <div key={key} className="price-card" style={{display:'flex', flexDirection:'column'}}>
                <TopicIcon name={key} size={40} />
                <div className="price-name">{label}</div>
                <div style={{fontSize:'13px', color:'#6b7280', lineHeight:1.55, marginBottom:'14px', minHeight:'58px'}}>{sub}</div>
                <div className="price-amount">
                  {owned ? <span style={{display:'inline-block', padding:'4px 14px', background:'white', color:'#16a34a', border:'1.5px solid #16a34a', fontSize:'13px', fontWeight:600, borderRadius:'20px'}}>✓ Aktivdir</span> : '₼29'}
                </div>
                <div className="price-desc">3 test · 75 sual · 2 ay</div>
                <div style={{flex:1}}></div>
                {owned
                  ? <button className="btn-primary btn-full" onClick={onDashboard}>Hazırlaş →</button>
                  : <>
                      <button className="btn-outline btn-full" style={{marginBottom:8}} onClick={() => onBuyOrAuth(key)}>Satın al</button>
                      <button className="btn-ghost-sm btn-full" onClick={() => onStart(key, 0)}>5 ödənişsiz sual →</button>
                    </>}
              </div>
            )
          })}
          <div className="price-card featured" style={{display:'flex', flexDirection:'column'}}>
            {!ownsBundle && <div className="save-badge" style={{fontSize:'13px', padding:'5px 14px'}}>28 ₼ qənaət</div>}
            <TopicIcon name="bundle" size={40} />
            <div className="price-name">Tam Paket</div>
            <div style={{fontSize:'13px', color:'#6b7280', lineHeight:1.55, marginBottom:'14px', minHeight:'58px'}}>Verbal + Rəqəmsal + Abstrakt · Ən sərfəli seçim</div>
            <div className="price-amount">
              {ownsBundle ? <span style={{display:'inline-block', padding:'4px 14px', background:'white', color:'#16a34a', border:'1.5px solid #16a34a', fontSize:'13px', fontWeight:600, borderRadius:'20px'}}>✓ Aktivdir</span> : '₼59'}
            </div>
            <div className="price-desc">9 test · 225 sual · 2 ay</div>
            <div style={{flex:1}}></div>
            {ownsBundle
              ? <button className="btn-primary btn-full" onClick={onDashboard}>Hazırlaş →</button>
              : <>
                  <button className="btn-primary btn-full" style={{marginBottom:8}} onClick={() => onBuyOrAuth('bundle')}>İndi al</button>
                  <button className="btn-ghost-sm btn-full" onClick={() => onStart('mix', 0)}>15 ödənişsiz sual →</button>
                </>}
          </div>
        </div>
      </div>

      <div className="topics-section" id="sample">
        <h2>Nümunə sual</h2>
        <p className="section-sub">Real testlərimizdən bir nümunə</p>
        <div style={{maxWidth:'620px', margin:'0 auto', background:'white', border:'1.5px solid #d1e4f7', borderRadius:'14px', padding:'28px', textAlign:'left'}}>
          <div style={{display:'inline-block', background:'#0a74da', color:'white', fontSize:'11px', fontWeight:700, padding:'3px 10px', borderRadius:'20px', marginBottom:'14px'}}>Rəqəmsal Təhlil · Nümunə</div>
          <div style={{fontSize:'15px', color:'#0c1f4a', lineHeight:1.65, marginBottom:'18px', fontWeight:500}}>
            Bir restoranda Aprel ayında 240 müştəri olub. Mayda müştəri sayı 25% artıb, İyunda isə əvvəlki aya görə 20% azalıb. İyun ayında neçə müştəri olub?
          </div>
          <div style={{display:'flex', flexDirection:'column', gap:'8px', marginBottom:'18px'}}>
            <SampleOpt letter="A" text="192" />
            <SampleOpt letter="B" text="216" />
            <SampleOpt letter="C" text="240 ✓ Düzgün cavab" correct />
            <SampleOpt letter="D" text="264" />
          </div>
          <div style={{background:'#f9fbff', padding:'12px 16px', borderRadius:'8px', fontSize:'13px', color:'#6b7280', lineHeight:1.55, marginBottom:'18px'}}>
            💡 May: 240 × 1.25 = 300 · İyun: 300 × 0.80 = 240. Faizlər simmetrik deyil, bərpa eyni səviyyəyə qaytarmır.
          </div>
          <div style={{textAlign:'center', fontSize:'14px', fontWeight:500}}>
            <span onClick={() => onStart('mix', 0)} style={{color:'#0a74da', cursor:'pointer'}}>Daha çox nümunə üçün ödənişsiz başlayın →</span>
          </div>
        </div>
      </div>

      <div className="footer-cta">
        <h2>Hazırlığa indi başlayın</h2>
        <button className="btn-white btn-lg" onClick={() => onStart('mix', 0)}>Ödənişsiz başla →</button>
      </div>
    </div>
  )
}

function SampleOpt({ letter, text, correct }) {
  return (
    <div style={{
      border: correct ? '1.5px solid #16a34a' : '1px solid #e5e7eb',
      background: correct ? '#f0fdf4' : 'white',
      padding: '11px 14px', borderRadius: '8px', fontSize: '14px',
      color: correct ? '#0c1f4a' : '#4b5563',
      fontWeight: correct ? 600 : 400,
      display: 'flex', alignItems: 'center', gap: '10px',
    }}>
      <div style={{
        width: '22px', height: '22px', borderRadius: '6px',
        background: correct ? '#16a34a' : 'transparent',
        border: correct ? 'none' : '1px solid #d1e4f7',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: '12px', fontWeight: correct ? 700 : 600,
        color: correct ? 'white' : '#6b7280', flexShrink: 0,
      }}>{letter}</div>
      {text}
    </div>
  )
}

// ─── AUTH ─────────────────────────────────────────────────────────────────────

function Auth({ onSuccess, onBack, initialMode = 'login' }) {
  const [mode, setMode] = useState(initialMode)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handle = async (e) => {
    e.preventDefault(); setError(''); setLoading(true)
    try {
      if (mode === 'login') {
        const { data, error } = await supabase.auth.signInWithPassword({ email, password })
        if (error) throw error
        onSuccess(data.user)
      } else if (mode === 'register') {
        const { data, error } = await supabase.auth.signUp({ email, password, options: { data: { full_name: (firstName.trim() + ' ' + lastName.trim()).trim() } } })
        if (error) throw error
        if (data.user) onSuccess(data.user)
        else setError('Emailinizi yoxlayın, təsdiq linki göndərildi.')
      } else if (mode === 'reset-request') {
        const { error } = await supabase.auth.resetPasswordForEmail(email, {
          redirectTo: `${window.location.origin}/sifre-yenile`,
        })
        if (error) throw error
        setMode('reset-sent')
      }
    } catch (err) {
      const msg = err.message || ''
      let translated = msg
      if (msg === 'Invalid login credentials') translated = 'Email və ya şifrə yanlışdır.'
      else if (msg.toLowerCase().includes('rate limit')) translated = 'Çox tez-tez sınadınız. Bir az gözləyin və yenidən cəhd edin.'
      else if (msg.toLowerCase().includes('user already registered')) translated = 'Bu email artıq qeydiyyatdan keçib. Daxil olun.'
      else if (msg.toLowerCase().includes('email not confirmed')) translated = 'Əvvəlcə email-i təsdiqləyin. Spam qovluğunu yoxlayın.'
      else if (msg.toLowerCase().includes('password should be')) translated = 'Şifrə minimum 6 simvol olmalıdır.'
      setError(translated)
    }
    setLoading(false)
  }

  // ─── Reset email sent confirmation
  if (mode === 'reset-sent') {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div style={{marginBottom:'12px'}}>
            <button className="back-btn" onClick={onBack} style={{position:'static', float:'none', display:'inline-block'}}>← Geri</button>
          </div>
          <Logo onClick={onBack} />
          <h2>Email göndərildi ✓</h2>
          <p style={{fontSize:'14px', color:'#4b5563', lineHeight:1.6, textAlign:'center', margin:'16px 0 24px'}}>
            <strong>{email}</strong> ünvanına şifrə yeniləmə linki göndərildi. Spam qovluğunu da yoxlayın.
          </p>
          <button className="btn-outline btn-full" onClick={() => { setMode('login'); setError('') }}>
            Daxil olma səhifəsinə qayıt
          </button>
        </div>
      </div>
    )
  }

  // ─── Reset request form (email-only)
  if (mode === 'reset-request') {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div style={{marginBottom:'12px'}}>
            <button className="back-btn" onClick={onBack} style={{position:'static', float:'none', display:'inline-block'}}>← Geri</button>
          </div>
          <Logo onClick={onBack} />
          <h2>Şifrə yenilənməsi</h2>
          <p style={{fontSize:'13px', color:'#6b7280', lineHeight:1.55, textAlign:'center', margin:'10px 0 18px'}}>
            Hesab email-inizi daxil edin. Sizə yeniləmə linki göndərəcəyik.
          </p>
          <form onSubmit={handle}>
            <input className="input" type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required />
            {error && <div className="error-msg">{error}</div>}
            <button className="btn-primary btn-full" type="submit" disabled={loading}>
              {loading ? 'Yüklənir...' : 'Yeniləmə linkini göndər'}
            </button>
          </form>
          <div className="auth-switch">
            <span onClick={() => { setMode('login'); setError('') }}>← Daxil olma səhifəsinə qayıt</span>
          </div>
        </div>
      </div>
    )
  }

  // ─── Login / Register
  return (
    <div className="auth-page">
      <div className="auth-card">
        <div style={{marginBottom:'12px'}}>
          <button className="back-btn" onClick={onBack} style={{position:'static', float:'none', display:'inline-block'}}>← Geri</button>
        </div>
        <Logo onClick={onBack} />
        <h2>{mode === 'login' ? 'Daxil ol' : 'Qeydiyyat'}</h2>
        <form onSubmit={handle}>
          {mode === 'register' && <input className="input" placeholder="Ad" value={firstName} onChange={e => setFirstName(e.target.value)} required />}
          {mode === 'register' && <input className="input" placeholder="Soyad" value={lastName} onChange={e => setLastName(e.target.value)} required />}
          <input className="input" type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required />
          <input className="input" type="password" placeholder="Şifrə (min. 6 simvol)" value={password} onChange={e => setPassword(e.target.value)} required minLength={6} />
          {mode === 'login' && (
            <div style={{textAlign:'right', marginTop:'-6px', marginBottom:'12px'}}>
              <span
                onClick={() => { setMode('reset-request'); setError(''); setPassword('') }}
                style={{fontSize:'13px', color:'#0a74da', cursor:'pointer', textDecoration:'underline'}}
              >Şifrəni unutdum</span>
            </div>
          )}
          {error && <div className="error-msg">{error}</div>}
          <button className="btn-primary btn-full" type="submit" disabled={loading}>
            {loading ? 'Yüklənir...' : mode === 'login' ? 'Daxil ol' : 'Qeydiyyatdan keç'}
          </button>
        </form>
        <div className="auth-switch">
          {mode === 'login'
            ? <>Hesabınız yoxdur? <span onClick={() => setMode('register')}>Qeydiyyat</span></>
            : <>Hesabınız var? <span onClick={() => setMode('login')}>Daxil ol</span></>}
        </div>
      </div>
    </div>
  )
}

// ─── PASSWORD RESET PAGE ──────────────────────────────────────────────────────

function PasswordResetPage({ onSuccess, onBack }) {
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [done, setDone] = useState(false)
  const [ready, setReady] = useState(false)
  const [sessionMissing, setSessionMissing] = useState(false)

  useEffect(() => {
    // Check if Supabase already established a session from the URL hash
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) setReady(true)
    })

    // Listen for the recovery event Supabase fires after reading the hash
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'PASSWORD_RECOVERY' || (event === 'SIGNED_IN' && session)) {
        setReady(true)
      }
    })

    // If after 4 seconds we still have no session, the link is bad or expired
    const timer = setTimeout(() => {
      supabase.auth.getSession().then(({ data: { session } }) => {
        if (!session) setSessionMissing(true)
      })
    }, 4000)

    return () => {
      subscription.unsubscribe()
      clearTimeout(timer)
    }
  }, [])

  const handle = async (e) => {
    e.preventDefault(); setError('')
    if (password.length < 6) { setError('Şifrə minimum 6 simvol olmalıdır.'); return }
    if (password !== confirm) { setError('Şifrələr uyğun gəlmir.'); return }
    setLoading(true)
    try {
      const { error } = await supabase.auth.updateUser({ password })
      if (error) throw error
      setDone(true)
      setTimeout(() => onSuccess(), 1500)
    } catch (err) {
      setError(err.message)
    }
    setLoading(false)
  }

  if (done) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <Logo onClick={onBack} />
          <h2 style={{color:'#16a34a'}}>Şifrə yeniləndi ✓</h2>
          <p style={{fontSize:'14px', color:'#4b5563', textAlign:'center', margin:'16px 0'}}>
            Kabinetə yönləndirilirsiniz...
          </p>
        </div>
      </div>
    )
  }

  if (sessionMissing) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <Logo onClick={onBack} />
          <h2>Link yararsızdır</h2>
          <p style={{fontSize:'14px', color:'#4b5563', textAlign:'center', lineHeight:1.6, margin:'16px 0 24px'}}>
            Şifrə yeniləmə linki vaxtı keçib və ya artıq istifadə olunub. Yeni link tələb edin.
          </p>
          <button className="btn-primary btn-full" onClick={onBack}>
            Yeni link tələb et
          </button>
        </div>
      </div>
    )
  }

  if (!ready) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <Logo onClick={onBack} />
          <p style={{fontSize:'14px', color:'#6b7280', textAlign:'center', margin:'24px 0'}}>
            Yüklənir...
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <Logo onClick={onBack} />
        <h2>Yeni şifrə təyin edin</h2>
        <p style={{fontSize:'13px', color:'#6b7280', lineHeight:1.55, textAlign:'center', margin:'10px 0 18px'}}>
          Yeni şifrənizi daxil edin.
        </p>
        <form onSubmit={handle}>
          <input className="input" type="password" placeholder="Yeni şifrə (min. 6 simvol)" value={password} onChange={e => setPassword(e.target.value)} required minLength={6} />
          <input className="input" type="password" placeholder="Şifrəni təkrar daxil edin" value={confirm} onChange={e => setConfirm(e.target.value)} required minLength={6} />
          {error && <div className="error-msg">{error}</div>}
          <button className="btn-primary btn-full" type="submit" disabled={loading}>
            {loading ? 'Yüklənir...' : 'Şifrəni yenilə'}
          </button>
        </form>
      </div>
    </div>
  )
}

// ─── DASHBOARD ────────────────────────────────────────────────────────────────

function Dashboard({ user, purchases, hasPurchased, onStart, onBuy, onCourse, onLogout, onHome, onNav }) {
  const sections = [
    { key:'verbal',   label:'Verbal Təhlil',   sub:'Oxuyub-anlama · Boşluq doldurma · Məntiqi nəticə çıxarma' },
    { key:'reqemsal', label:'Rəqəmsal Təhlil', sub:'Cədvəl və diaqramlar · Faiz hesablamaları · Statistik təhlil' },
    { key:'abstrakt', label:'Abstrakt Təhlil', sub:'Fiqur ardıcıllığı · Vizual qanunauyğunluqlar · Məntiqi düşünmə' },
  ]
  const ownsBundle = purchases.includes('bundle')
  const [pickerTopic, setPickerTopic] = useState(null)

  const fullName = user?.user_metadata?.full_name || ''
  const firstName = fullName.trim().split(/\s+/)[0] || 'dostum'

  return (
    <div className="dashboard">
      <nav className="nav">
        <Logo onClick={onHome} />
        <div className="nav-links"></div>
        <div className="nav-actions">
          <span className="user-email">{user?.email}</span>
          <button className="btn-ghost" onClick={onLogout}>Çıxış</button>
        </div>
      </nav>
      <div className="dash-content">

        <div style={{display:'flex', alignItems:'center', gap:'18px', marginBottom:'24px'}}>
          <div style={{width:'56px', height:'56px', borderRadius:'50%', background:'#0a74da', overflow:'hidden', flexShrink:0}}>
            <svg width="56" height="56" viewBox="0 0 52 52" style={{display:'block'}}>
              <g transform="rotate(15,26,26)">
                <rect x="13" y="2"  width="6"  height="48" rx="3"   fill="white"/>
                <rect x="33" y="2"  width="6"  height="48" rx="3"   fill="white"/>
                <rect x="13" y="8"  width="26" height="5"  rx="2.5" fill="white"/>
                <rect x="13" y="21" width="26" height="5"  rx="2.5" fill="white"/>
                <rect x="13" y="34" width="26" height="5"  rx="2.5" fill="white"/>
              </g>
            </svg>
          </div>
          <h1 style={{fontSize:'32px', fontWeight:700, color:'#0c1f4a', letterSpacing:'-0.5px', margin:0}}>
            Salam, {firstName}! 👋
          </h1>
        </div>

        <div style={{background:'#f0f7ff', borderLeft:'4px solid #0a74da', padding:'18px 22px', borderRadius:'10px', marginBottom:'32px'}}>
          <div style={{fontSize:'17px', fontWeight:700, color:'#0a74da', letterSpacing:'0.5px', marginBottom:'6px'}}>
            pillə
          </div>
          <div style={{fontSize:'17px', color:'#0c1f4a', fontWeight:500}}>
            Hazırlıq mərkəzinə xoş gəlmisiniz! ✨
          </div>
        </div>

        <h2 style={{fontSize:'22px', fontWeight:700, color:'#0c1f4a', marginBottom:'8px'}}>İdarəetmə Bacarıqları proqramları</h2>
        <p style={{fontSize:'15px', color:'#6b7280', marginBottom:'24px'}}>Dərslər, quizlər və izahlı materiallar</p>

        <div className="pricing-grid pricing-grid-4">
          {[{slug:'smt', name:'Situasiya Mühakiməsi', sub:'İdarəetmə situasiyalarında düzgün qərarvermə bacarığı', desc:'12 dərs · 3 test · 252 sual'},
            {slug:'ez', name:'Emosional Zəka', sub:'Emosiyaları qavrama, anlama və idarə etmə bacarığı', desc:'9 dərs · 3 test · 234 sual'}].map(c => {
            const ownsC = hasPurchased(c.slug)
            return (
              <div key={c.slug} className="price-card" style={{display:'flex', flexDirection:'column'}}>
                <TopicIcon name={c.slug} size={40} />
                <div className="price-name">{c.name}</div>
                <div style={{fontSize:'13px', color:'#6b7280', lineHeight:1.55, marginBottom:'14px', minHeight:'58px'}}>{c.sub}</div>
                <div className="price-amount">
                  {ownsC ? <span style={{display:'inline-block', padding:'4px 14px', background:'white', color:'#16a34a', border:'1.5px solid #16a34a', fontSize:'13px', fontWeight:600, borderRadius:'20px'}}>✓ Aktivdir</span> : '₼49'}
                </div>
                <div className="price-desc">{c.desc}</div>
                <div style={{flex:1}}></div>
                {ownsC
                  ? <button className="btn-primary btn-full" onClick={() => onCourse(c.slug)}>Davam et →</button>
                  : <>
                      <button className="btn-outline btn-full" style={{marginBottom:8}} onClick={() => onBuy(c.slug)}>Satın al</button>
                      <button className="btn-ghost-sm btn-full" onClick={() => onCourse(c.slug)}>Dərslərə bax →</button>
                    </>}
              </div>
            )
          })}
          {(() => {
            const ownsIdareetme = purchases.includes('idareetme')
            return (
              <div className="price-card featured" style={{display:'flex', flexDirection:'column'}}>
                {!ownsIdareetme && <div className="save-badge" style={{fontSize:'13px', padding:'5px 14px'}}>39 ₼ qənaət</div>}
                <TopicIcon name="idareetme" size={40} />
                <div className="price-name">İdarəetmə Bacarıqları</div>
                <div style={{fontSize:'13px', color:'#6b7280', lineHeight:1.55, marginBottom:'14px', minHeight:'58px'}}>Situasiya Mühakiməsi + Emosional Zəka · Ən sərfəli seçim</div>
                <div className="price-amount">
                  {ownsIdareetme ? <span style={{display:'inline-block', padding:'4px 14px', background:'white', color:'#16a34a', border:'1.5px solid #16a34a', fontSize:'13px', fontWeight:600, borderRadius:'20px'}}>✓ Aktivdir</span> : '₼59'}
                </div>
                <div className="price-desc">21 dərs · 6 test · 486 sual</div>
                <div style={{flex:1}}></div>
                {ownsIdareetme
                  ? <button className="btn-primary btn-full" onClick={() => onCourse('smt')}>Davam et →</button>
                  : <button className="btn-primary btn-full" onClick={() => onBuy('idareetme')}>İndi al</button>}
              </div>
            )
          })()}
        </div>

        <h2 style={{fontSize:'22px', fontWeight:700, color:'#0c1f4a', margin:'48px 0 8px'}}>Hansı bölmədən başlayaq?</h2>
        <p style={{fontSize:'15px', color:'#6b7280', marginBottom:'32px'}}>Seçim edin və 5 ödənişsiz sual ilə başlayın</p>

        <div className="pricing-grid pricing-grid-4">
          {sections.map(({ key, label, sub }) => {
            const owned = hasPurchased(key)
            return (
              <div key={key} className="price-card" style={{display:'flex', flexDirection:'column'}}>
                <TopicIcon name={key} size={40} />
                <div className="price-name">{label}</div>
                <div style={{fontSize:'13px', color:'#6b7280', lineHeight:1.55, marginBottom:'14px', minHeight:'58px'}}>{sub}</div>
                <div className="price-amount">
                  {owned ? <span style={{display:'inline-block', padding:'4px 14px', background:'white', color:'#16a34a', border:'1.5px solid #16a34a', fontSize:'13px', fontWeight:600, borderRadius:'20px'}}>✓ Aktivdir</span> : '₼29'}
                </div>
                <div className="price-desc">3 test · 75 sual · 2 ay</div>
                <div style={{flex:1}}></div>
                {owned
                  ? <button className="btn-primary btn-full" onClick={() => setPickerTopic(key)}>Testə başla →</button>
                  : <>
                      <button className="btn-outline btn-full" style={{marginBottom:8}} onClick={() => onBuy(key)}>Satın al</button>
                      <button className="btn-ghost-sm btn-full" onClick={() => onStart(key, 0)}>5 ödənişsiz sual →</button>
                    </>}
              </div>
            )
          })}
          <div className="price-card featured" style={{display:'flex', flexDirection:'column'}}>
            {!ownsBundle && <div className="save-badge" style={{fontSize:'13px', padding:'5px 14px'}}>28 ₼ qənaət</div>}
            <TopicIcon name="bundle" size={40} />
            <div className="price-name">Tam Paket</div>
            <div style={{fontSize:'13px', color:'#6b7280', lineHeight:1.55, marginBottom:'14px', minHeight:'58px'}}>Verbal + Rəqəmsal + Abstrakt · Ən sərfəli seçim</div>
            <div className="price-amount">
              {ownsBundle ? <span style={{display:'inline-block', padding:'4px 14px', background:'white', color:'#16a34a', border:'1.5px solid #16a34a', fontSize:'13px', fontWeight:600, borderRadius:'20px'}}>✓ Aktivdir</span> : '₼59'}
            </div>
            <div className="price-desc">9 test · 225 sual · 2 ay</div>
            <div style={{flex:1}}></div>
            {ownsBundle
              ? <button className="btn-primary btn-full" onClick={() => setPickerTopic('verbal')}>Testə başla →</button>
              : <>
                  <button className="btn-primary btn-full" style={{marginBottom:8}} onClick={() => onBuy('bundle')}>İndi al</button>
                  <button className="btn-ghost-sm btn-full" onClick={() => onStart('mix', 0)}>15 ödənişsiz sual →</button>
                </>}
          </div>
        </div>
      </div>

      {pickerTopic && (
        <TestPickerModal
          topic={pickerTopic}
          label={TOPICS[pickerTopic]?.label || pickerTopic}
          onSelect={(testNum) => { setPickerTopic(null); onStart(pickerTopic, testNum) }}
          onClose={() => setPickerTopic(null)}
        />
      )}
    </div>
  )
}

function TestPickerModal({ topic, label, onSelect, onClose }) {
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(12, 31, 74, 0.55)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        zIndex: 1000,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'white',
          borderRadius: '16px',
          padding: '32px 28px 24px',
          maxWidth: '380px',
          width: '100%',
          boxShadow: '0 20px 50px rgba(0,0,0,0.18)',
        }}
      >
        <div style={{textAlign: 'center', marginBottom: '24px'}}>
          <div style={{fontSize: '12px', fontWeight: 700, color: '#0a74da', letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: '6px'}}>{label}</div>
          <h2 style={{fontSize: '22px', fontWeight: 700, color: '#0c1f4a', margin: 0}}>Seçim edin</h2>
        </div>

        <div style={{display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px'}}>
          {[1, 2, 3].map(testNum => (
            <button
              key={testNum}
              onClick={() => onSelect(testNum)}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '16px 18px',
                background: '#f0f7ff',
                border: '1.5px solid #d1e4f7',
                borderRadius: '12px',
                cursor: 'pointer',
                textAlign: 'left',
                width: '100%',
                fontFamily: 'inherit',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.background = '#e8f3ff'; e.currentTarget.style.borderColor = '#0a74da' }}
              onMouseLeave={(e) => { e.currentTarget.style.background = '#f0f7ff'; e.currentTarget.style.borderColor = '#d1e4f7' }}
            >
              <div>
                <div style={{fontSize: '16px', fontWeight: 600, color: '#0c1f4a', marginBottom: '2px'}}>Test {testNum}</div>
                <div style={{fontSize: '13px', color: '#6b7280'}}>25 sual · 50 dəqiqə</div>
              </div>
              <span style={{color: '#0a74da', fontSize: '20px', fontWeight: 500}}>→</span>
            </button>
          ))}

          <button
            onClick={() => onSelect(0)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '16px 18px',
              background: 'white',
              border: '1.5px solid #e5e7eb',
              borderRadius: '12px',
              cursor: 'pointer',
              textAlign: 'left',
              width: '100%',
              fontFamily: 'inherit',
              marginTop: '4px',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = '#f9fafb'; e.currentTarget.style.borderColor = '#0a74da' }}
            onMouseLeave={(e) => { e.currentTarget.style.background = 'white'; e.currentTarget.style.borderColor = '#e5e7eb' }}
          >
            <div>
              <div style={{fontSize: '16px', fontWeight: 600, color: '#0c1f4a', marginBottom: '2px'}}>5 ödənişsiz sual</div>
              <div style={{fontSize: '13px', color: '#6b7280'}}>5 sual · 10 dəqiqə</div>
            </div>
            <span style={{color: '#0a74da', fontSize: '20px', fontWeight: 500}}>→</span>
          </button>
        </div>

        <button
          onClick={onClose}
          style={{
            width: '100%',
            padding: '12px',
            background: 'transparent',
            border: 'none',
            color: '#6b7280',
            fontSize: '14px',
            cursor: 'pointer',
            fontFamily: 'inherit',
          }}
        >Ləğv et</button>
      </div>
    </div>
  )
}

// ─── TEST SCREEN ──────────────────────────────────────────────────────────────

function TestScreen({ user, testState, setTestState, onFinish, onExit, onAuthSuccess }) {
  const { questions, answers, current, pendingStart, showingTransition } = testState
  const isMixTest = testState.topic === 'mix'

  const SECTION_NAMES = ['Verbal Təhlil', 'Rəqəmsal Təhlil', 'Abstrakt Təhlil']
  const QUESTIONS_PER_SECTION = 5
  const SECTION_TIME = 600

  const sectionIndex = isMixTest ? Math.min(2, Math.floor(current / QUESTIONS_PER_SECTION)) : 0
  const sectionStart = sectionIndex * QUESTIONS_PER_SECTION
  const sectionEndIdx = sectionStart + QUESTIONS_PER_SECTION - 1
  const isLastInSection = isMixTest && current === sectionEndIdx
  const isFinalSection = isMixTest && sectionIndex === 2

  const initialTime = isMixTest ? SECTION_TIME : questions.length * 120
  const [timeLeft, setTimeLeft] = useState(initialTime)
  const [hintsShown, setHintsShown] = useState({})
  const answersRef = useRef(answers)
  const hintsShownRef = useRef(hintsShown)
  useEffect(() => { answersRef.current = answers }, [answers])
  useEffect(() => { hintsShownRef.current = hintsShown }, [hintsShown])

  const showGate = !user && isMixTest && showingTransition && sectionIndex === 0

  useEffect(() => {
    if (pendingStart || showingTransition) return
    const t = setInterval(() => {
      setTimeLeft(p => {
        if (p <= 1) {
          clearInterval(t)
          if (isMixTest && !isFinalSection) {
            setTestState(prev => ({ ...prev, showingTransition: true }))
          } else {
            onFinish(answersRef.current, Object.keys(hintsShownRef.current).length)
          }
          return 0
        }
        return p - 1
      })
    }, 1000)
    return () => clearInterval(t)
  }, [pendingStart, showingTransition, isMixTest, isFinalSection])

  const advanceToNextSection = () => {
    const nextSectionStart = (sectionIndex + 1) * QUESTIONS_PER_SECTION
    setTestState(prev => ({
      ...prev,
      current: nextSectionStart,
      showingTransition: false,
    }))
    setTimeLeft(SECTION_TIME)
  }

  const handleSectionEnd = () => {
    if (isFinalSection) {
      onFinish(answersRef.current, Object.keys(hintsShownRef.current).length)
    } else {
      setTestState(prev => ({ ...prev, showingTransition: true }))
    }
  }

  if (showGate) {
    return <MidTestGate
      onSuccess={(u) => { onAuthSuccess(u); advanceToNextSection() }}
      onCancel={onExit}
      completedSection={SECTION_NAMES[0]}
      remaining={questions.length - QUESTIONS_PER_SECTION}
    />
  }

  if (showingTransition) {
    const completedIdx = sectionIndex
    const nextIdx = sectionIndex + 1
    const nextName = SECTION_NAMES[nextIdx]
    const remainingMsg = nextIdx === 1
      ? 'Bu bölmədən sonra Abstrakt Təhlil bölməsi Sizi gözləyir'
      : 'Son bölmə · Testi tamamlamaq üçün davam edin'

    return (
      <div className="test-page" style={{display:'flex', alignItems:'center', justifyContent:'center', padding:'40px 20px', minHeight:'100vh'}}>
        <div style={{background:'white', borderRadius:'16px', padding:'44px 36px', maxWidth:'460px', width:'100%', textAlign:'center', boxShadow:'0 4px 24px rgba(10,116,218,0.14)'}}>
          <div style={{display:'flex', justifyContent:'center', alignItems:'center', gap:'10px', marginBottom:'26px'}}>
            {SECTION_NAMES.map((name, i) => {
              const short = name.split(' ')[0]
              const isDone = i <= completedIdx
              const isActive = i === nextIdx
              return (
                <React.Fragment key={name}>
                  <span style={{
                    fontSize:'12px',
                    color: isDone ? '#16a34a' : isActive ? '#0a74da' : '#9ca3af',
                    fontWeight: (isDone || isActive) ? 700 : 500,
                    letterSpacing:'0.3px',
                    display:'inline-flex', alignItems:'center', gap:'6px',
                  }}>
                    <span style={{
                      width:'10px', height:'10px', borderRadius:'50%',
                      background: isDone ? '#16a34a' : isActive ? '#0a74da' : '#d1d5db',
                      display:'inline-flex', alignItems:'center', justifyContent:'center',
                      color:'white', fontSize:'8px', fontWeight:900, lineHeight:1,
                    }}>{isDone ? '✓' : ''}</span>
                    {short}
                  </span>
                  {i < SECTION_NAMES.length - 1 && (
                    <span style={{color:'#d1d5db', fontSize:'12px'}}>·</span>
                  )}
                </React.Fragment>
              )
            })}
          </div>

          <h2 style={{fontSize:'26px', fontWeight:700, color:'#0c1f4a', marginBottom:'4px', letterSpacing:'-0.5px'}}>{nextName}</h2>

          <div style={{display:'flex', justifyContent:'center', gap:'48px', margin:'28px 0 24px'}}>
            <div>
              <div style={{fontSize:'44px', fontWeight:800, color:'#0958a8', lineHeight:1, letterSpacing:'-1.5px'}}>5</div>
              <div style={{fontSize:'13px', color:'#6b7280', marginTop:'6px', fontWeight:500}}>Sual</div>
            </div>
            <div>
              <div style={{fontSize:'44px', fontWeight:800, color:'#0958a8', lineHeight:1, letterSpacing:'-1.5px'}}>10</div>
              <div style={{fontSize:'13px', color:'#6b7280', marginTop:'6px', fontWeight:500}}>Dəqiqə</div>
            </div>
          </div>

          <div style={{fontSize:'13px', color:'#0a74da', fontWeight:500, padding:'11px 16px', background:'#f0f7ff', borderRadius:'10px', marginBottom:'22px', lineHeight:1.55}}>
            {remainingMsg}
          </div>

          <button className="btn-primary btn-lg" style={{width:'100%'}} onClick={advanceToNextSection}>
            {nextName} suallarına başla →
          </button>
        </div>
      </div>
    )
  }

  if (pendingStart) {
    const startNow = () => {
      setTestState(prev => ({ ...prev, pendingStart: false, startTime: Date.now() }))
    }

    if (isMixTest) {
      return (
        <div className="test-page" style={{display:'flex', alignItems:'center', justifyContent:'center', padding:'40px 20px', minHeight:'100vh'}}>
          <div style={{background:'white', borderRadius:'16px', padding:'44px 36px', maxWidth:'460px', width:'100%', textAlign:'center', boxShadow:'0 4px 24px rgba(10,116,218,0.14)'}}>
            <div style={{display:'flex', justifyContent:'center', alignItems:'center', gap:'10px', marginBottom:'26px'}}>
              {SECTION_NAMES.map((name, i) => {
                const short = name.split(' ')[0]
                const isActive = i === 0
                return (
                  <React.Fragment key={name}>
                    <span style={{
                      fontSize:'12px',
                      color: isActive ? '#0a74da' : '#9ca3af',
                      fontWeight: isActive ? 700 : 500,
                      letterSpacing:'0.3px',
                      display:'inline-flex', alignItems:'center', gap:'6px',
                    }}>
                      <span style={{
                        width:'8px', height:'8px', borderRadius:'50%',
                        background: isActive ? '#0a74da' : '#d1d5db',
                        display:'inline-block',
                      }}></span>
                      {short}
                    </span>
                    {i < SECTION_NAMES.length - 1 && (
                      <span style={{color:'#d1d5db', fontSize:'12px'}}>·</span>
                    )}
                  </React.Fragment>
                )
              })}
            </div>
            <h2 style={{fontSize:'26px', fontWeight:700, color:'#0c1f4a', marginBottom:'4px', letterSpacing:'-0.5px'}}>Verbal Təhlil</h2>

            <div style={{display:'flex', justifyContent:'center', gap:'48px', margin:'28px 0 24px'}}>
              <div>
                <div style={{fontSize:'44px', fontWeight:800, color:'#0958a8', lineHeight:1, letterSpacing:'-1.5px'}}>5</div>
                <div style={{fontSize:'13px', color:'#6b7280', marginTop:'6px', fontWeight:500}}>Sual</div>
              </div>
              <div>
                <div style={{fontSize:'44px', fontWeight:800, color:'#0958a8', lineHeight:1, letterSpacing:'-1.5px'}}>10</div>
                <div style={{fontSize:'13px', color:'#6b7280', marginTop:'6px', fontWeight:500}}>Dəqiqə</div>
              </div>
            </div>

            <div style={{fontSize:'13px', color:'#0a74da', fontWeight:500, padding:'11px 16px', background:'#f0f7ff', borderRadius:'10px', marginBottom:'22px', lineHeight:1.55}}>
              Bu bölmədən sonra Rəqəmsal Təhlil və Abstrakt Təhlil bölmələri Sizi gözləyir
            </div>

            <button className="btn-primary btn-lg" style={{width:'100%', marginBottom:'10px'}} onClick={startNow}>
              {testState.quizLabel ? 'Quizə başla →' : (topicLabel + ' suallarına başla →')}
            </button>
            <button className="btn-ghost" style={{width:'100%'}} onClick={onExit}>
              ← Geri
            </button>
          </div>
        </div>
      )
    }

    const minutes = Math.round((questions.length * 120) / 60)
    const topicLabel = testState.quizLabel || TOPICS[testState.topic]?.label || testState.topic
    const testLabel  = testState.quizLesson ? `Quiz ${testState.quizLesson}` : testState.quizMock ? `Test ${testState.quizMock}` : (testState.testNum > 0 ? `Test ${testState.testNum}` : 'Ödənişsiz nümunə')

    return (
      <div className="test-page" style={{display:'flex', alignItems:'center', justifyContent:'center', padding:'40px 20px', minHeight:'100vh'}}>
        <div style={{background:'white', borderRadius:'16px', padding:'44px 36px', maxWidth:'440px', width:'100%', textAlign:'center', boxShadow:'0 4px 24px rgba(10,116,218,0.14)'}}>
          <div style={{fontSize:'12px', fontWeight:700, color:'#0a74da', letterSpacing:'1.5px', textTransform:'uppercase', marginBottom:'10px'}}>{testLabel}</div>
          <h2 style={{fontSize:'24px', fontWeight:700, color:'#0c1f4a', marginBottom:'32px'}}>{topicLabel}</h2>
          <div style={{display:'flex', justifyContent:'center', gap:'48px', marginBottom:'24px'}}>
            <div>
              <div style={{fontSize:'40px', fontWeight:800, color:'#0958a8', lineHeight:1, letterSpacing:'-1px'}}>{questions.length}</div>
              <div style={{fontSize:'12px', color:'#6b7280', marginTop:'6px', fontWeight:500}}>Sual</div>
            </div>
            <div>
              <div style={{fontSize:'40px', fontWeight:800, color:'#0958a8', lineHeight:1, letterSpacing:'-1px'}}>{minutes}</div>
              <div style={{fontSize:'12px', color:'#6b7280', marginTop:'6px', fontWeight:500}}>Dəqiqə</div>
            </div>
          </div>
          <div style={{fontSize:'13px', color:'#6b7280', marginBottom:'24px', lineHeight:1.6, padding:'12px 16px', background:'#f9fbff', borderRadius:'10px'}}>
            Düyməyə basdığınız andan vaxt geri sayımı dərhal başlayır.
          </div>
          <button className="btn-primary btn-lg" style={{width:'100%', marginBottom:'12px'}} onClick={startNow}>
            {testState.quizLesson ? 'Quizə başla →' : 'Testə başla →'}
          </button>
          <button className="btn-ghost" style={{width:'100%'}} onClick={onExit}>
            ← Geri
          </button>
        </div>
      </div>
    )
  }

  const q = questions[current]
  const fmt = (s) => `${Math.floor(s/60).toString().padStart(2,'0')}:${(s%60).toString().padStart(2,'0')}`
  const answer = (opt) => setTestState(prev => ({ ...prev, answers: { ...prev.answers, [q.id]: opt } }))
  // Richer setters for the multi-part formats (dual / ranking / likert).
  const setAnswer = (val) => setTestState(prev => ({ ...prev, answers: { ...prev.answers, [q.id]: val } }))
  const cur = answers[q.id]
  const pickDual = (slot, key) => {
    const base = (cur && typeof cur === 'object' && !Array.isArray(cur)) ? cur : {}
    const next = { ...base }
    if (next[slot] === key) { delete next[slot] }            // tap again to clear
    else {
      next[slot] = key
      const other = slot === 'best' ? 'worst' : 'best'
      if (next[other] === key) delete next[other]            // an option can't be both
    }
    setAnswer(Object.keys(next).length ? next : undefined)
  }
  const pickRank = (key) => {
    const arr = Array.isArray(cur) ? [...cur] : []
    const at = arr.indexOf(key)
    if (at === -1) arr.push(key); else arr.splice(at, 1)
    setAnswer(arr.length ? arr : undefined)
  }
  const pickLikert = (key, val) => {
    const base = (cur && typeof cur === 'object' && !Array.isArray(cur)) ? cur : {}
    setAnswer({ ...base, [key]: val })
  }
  const go = (dir) => {
    const n = current + dir
    if (isMixTest) {
      if (n < sectionStart || n > sectionEndIdx) return
    } else {
      if (n < 0 || n >= questions.length) return
    }
    setTestState(prev => ({ ...prev, current: n }))
  }

  const topicLabel = testState.quizLabel ? testState.quizLabel : isMixTest
    ? `Yüksəliş Müsabiqəsi, ${SECTION_NAMES[sectionIndex]}`
    : (TOPICS[testState.topic]?.label || testState.topic)
  const testLabel = testState.quizLesson ? `Quiz ${testState.quizLesson}` : testState.quizMock ? `Test ${testState.quizMock}` : isMixTest
    ? `Bölmə ${sectionIndex + 1}/3`
    : (testState.testNum > 0 ? `Test ${testState.testNum}` : 'Ödənişsiz nümunə')
  const isVerbalQ = q.topic === 'verbal'
  const answeredCount = Object.keys(answers).length
  const totalAnswered = isMixTest
    ? questions.slice(sectionStart, sectionEndIdx + 1).filter(qq => answers[qq.id]).length
    : answeredCount
  const sectionQuestions = isMixTest ? questions.slice(sectionStart, sectionEndIdx + 1) : questions
  const currentInSection = isMixTest ? current - sectionStart : current
  const totalInSection = isMixTest ? QUESTIONS_PER_SECTION : questions.length
  const pct = Math.round(((currentInSection + 1) / totalInSection) * 100)

  return (
    <div className="test-page">
      <div className="test-topbar">
        <Logo onClick={onExit} />
        <div className="topbar-center">
          <span className="test-title">{topicLabel}</span>
          <span className="test-progress-text">
            {isMixTest ? `${testLabel} · Sual ${currentInSection + 1}/${totalInSection}` : `Sual ${current + 1}/${questions.length}`}
          </span>
        </div>
        <div className={`timer-box ${timeLeft < 60 ? 'timer-urgent' : timeLeft < 180 ? 'timer-warn' : ''}`}>
          <span className="timer-icon">⏱</span>
          <span className="timer-val">{fmt(timeLeft)}</span>
        </div>
      </div>
      <div className="test-progress-bar">
        <div className="progress-fill" style={{ width: `${pct}%` }} />
      </div>
      <div className="test-layout">
        <div className="question-panel">
          {isVerbalQ && q.passage_text && (
            <div className="passage-box">
              <div className="passage-label">📖 Mətn</div>
              <div className="passage-text">{q.passage_text}</div>
            </div>
          )}
          <div className="q-header">
            <span className="q-badge">Sual {isMixTest ? currentInSection + 1 : current + 1}</span>
            <span className="q-pts">{q.points} bal</span>
            {q.q_type === 'multiselect' && <span className="q-multi-badge">Çoxlu seçim</span>}
          </div>
          <div className="q-text">{q.question_az}</div>
          {q.hint_az && q.hint_az.trim() && (
            hintsShown[q.id]
              ? <div className="q-hint">💡 {q.hint_az}</div>
              : <button
                  onClick={() => setHintsShown(prev => ({...prev, [q.id]: true}))}
                  style={{
                    background:'white', border:'1px solid #d1e4f7', color:'#0a74da',
                    padding:'7px 16px', fontSize:'13px', fontWeight:500,
                    borderRadius:'8px', cursor:'pointer', marginBottom:'14px',
                    display:'inline-block', fontFamily:'inherit',
                  }}
                >💡 İpucu göstər</button>
          )}
          {q.table_data && <TableDisplay data={q.table_data} />}
          {q.chart_data && <ChartDisplay data={q.chart_data} />}
          {q.svg_question && <SvgDisplay svgContent={q.svg_question} />}
          {q.q_type === 'dual' ? (
            <div className="options options-dual">
              <div className="dual-legend">
                <span className="dual-tag dual-tag-best">Ən effektiv</span>
                <span className="dual-tag dual-tag-worst">Ən az effektiv</span>
              </div>
              {Object.entries(q.options).map(([key, val]) => {
                const isBest = cur && cur.best === key
                const isWorst = cur && cur.worst === key
                return (
                  <div key={key} className={`option option-dual ${isBest ? 'sel-best' : ''} ${isWorst ? 'sel-worst' : ''}`}>
                    <div className={`opt-letter ${isBest || isWorst ? 'selected' : ''}`}>{key}</div>
                    <div className="opt-text">{val}</div>
                    <div className="dual-picks">
                      <button type="button" className={`dual-btn dual-btn-best ${isBest ? 'on' : ''}`} onClick={() => pickDual('best', key)}>✓ effektiv</button>
                      <button type="button" className={`dual-btn dual-btn-worst ${isWorst ? 'on' : ''}`} onClick={() => pickDual('worst', key)}>✗ az effektiv</button>
                    </div>
                  </div>
                )
              })}
            </div>
          ) : q.q_type === 'ranking' ? (
            <div className="options options-rank">
              <div className="rank-hint">Sıralayın: ən effektivdən (1) ən az effektivə doğru. Seçmək üçün toxunun, ləğv üçün təkrar toxunun.</div>
              {Object.entries(q.options).map(([key, val]) => {
                const pos = Array.isArray(cur) ? cur.indexOf(key) : -1
                return (
                  <div key={key} className={`option option-rank ${pos !== -1 ? 'selected' : ''}`} onClick={() => pickRank(key)}>
                    <div className={`opt-letter ${pos !== -1 ? 'selected' : ''}`}>{pos !== -1 ? pos + 1 : key}</div>
                    <div className="opt-text">{val}</div>
                  </div>
                )
              })}
            </div>
          ) : q.q_type === 'likert' ? (
            <div className="options options-likert">
              <div className="rank-hint">Hər variantı qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).</div>
              {Object.entries(q.options).map(([key, val]) => {
                const rating = (cur && typeof cur === 'object' && !Array.isArray(cur)) ? cur[key] : undefined
                return (
                  <div key={key} className={`option option-likert ${rating ? 'selected' : ''}`}>
                    <div className={`opt-letter ${rating ? 'selected' : ''}`}>{key}</div>
                    <div className="opt-text">{val}</div>
                    <div className="likert-scale">
                      {[1, 2, 3, 4].map(n => (
                        <button type="button" key={n} className={`likert-dot ${rating === n ? 'on' : ''}`} onClick={() => pickLikert(key, n)}>{n}</button>
                      ))}
                    </div>
                  </div>
                )
              })}
            </div>
          ) : (
            <div className="options">
              {Object.entries(q.options).map(([key, val]) => (
                <div key={key} className={`option ${cur === key ? 'selected' : ''}`} onClick={() => answer(key)}>
                  <div className={`opt-letter ${cur === key ? 'selected' : ''}`}>{key}</div>
                  {q.svg_options && q.svg_options[key]
                    ? <div dangerouslySetInnerHTML={{ __html: q.svg_options[key] }} style={{ width: 70, height: 70, flexShrink: 0 }} />
                    : <div className="opt-text">{val}</div>}
                </div>
              ))}
            </div>
          )}
          <div className="q-actions">
            <button className="btn-nav" onClick={() => go(-1)} disabled={isMixTest ? current === sectionStart : current === 0}>← Əvvəlki</button>
            <button className="btn-exit" onClick={onExit}>Çıxış</button>
            {isLastInSection && !isFinalSection
              ? <button className="btn-primary" onClick={handleSectionEnd}>Növbəti bölməyə keç →</button>
              : (isFinalSection && current === questions.length - 1) || (!isMixTest && current === questions.length - 1)
                ? <button className="btn-primary" onClick={() => onFinish(answers, Object.keys(hintsShown).length)}>Testi bitir ✓</button>
                : <button className="btn-nav btn-next" onClick={() => go(1)}>Növbəti →</button>}
          </div>
        </div>
        <div className="test-sidebar">
          <div className="sidebar-header">
            <div className="sidebar-title">{isMixTest ? SECTION_NAMES[sectionIndex] : 'Suallar'}</div>
            <div className="sidebar-stat">{totalAnswered}/{totalInSection} cavablandı</div>
          </div>
          <div className="q-grid">
            {sectionQuestions.map((qq, i) => {
              const absoluteIdx = isMixTest ? sectionStart + i : i
              return (
                <div
                  key={qq.id}
                  className={`q-dot ${absoluteIdx === current ? 'current' : answers[qq.id] ? 'answered' : ''}`}
                  onClick={() => setTestState(prev => ({ ...prev, current: absoluteIdx }))}
                >{i + 1}</div>
              )
            })}
          </div>
          <div className="sidebar-legend">
            <div className="legend-item"><div className="ld answered" />Cavablandı</div>
            <div className="legend-item"><div className="ld current" />Cari</div>
            <div className="legend-item"><div className="ld empty" />Boş</div>
          </div>
          {isLastInSection && !isFinalSection
            ? <button className="btn-primary btn-full" onClick={handleSectionEnd}>Növbəti bölməyə keç →</button>
            : <button className="btn-primary btn-full" onClick={() => onFinish(answers, Object.keys(hintsShown).length)}>Testi bitir ✓</button>}
        </div>
      </div>
    </div>
  )
}

// ─── MID-TEST AUTH GATE ──────────────────────────────────────────────────────

function MidTestGate({ onSuccess, onCancel, completedSection, remaining }) {
  const [mode, setMode] = useState('register')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handle = async (e) => {
    e.preventDefault(); setError(''); setLoading(true)
    try {
      if (mode === 'login') {
        const { data, error } = await supabase.auth.signInWithPassword({ email, password })
        if (error) throw error
        onSuccess(data.user)
      } else {
        const { data, error } = await supabase.auth.signUp({ email, password, options: { data: { full_name: (firstName.trim() + ' ' + lastName.trim()).trim() } } })
        if (error) throw error
        if (data.user) onSuccess(data.user)
        else setError('Emailinizi yoxlayın, təsdiq linki göndərildi.')
      }
    } catch (err) {
      const msg = err.message || ''
      let translated = msg
      if (msg === 'Invalid login credentials') translated = 'Email və ya şifrə yanlışdır.'
      else if (msg.toLowerCase().includes('rate limit')) translated = 'Çox tez-tez sınadınız. Bir az gözləyin və yenidən cəhd edin.'
      else if (msg.toLowerCase().includes('user already registered')) translated = 'Bu email artıq qeydiyyatdan keçib. Daxil olun.'
      else if (msg.toLowerCase().includes('email not confirmed')) translated = 'Əvvəlcə email-i təsdiqləyin. Spam qovluğunu yoxlayın.'
      else if (msg.toLowerCase().includes('password should be')) translated = 'Şifrə minimum 6 simvol olmalıdır.'
      setError(translated)
    }
    setLoading(false)
  }

  return (
    <div className="test-page" style={{display:'flex', alignItems:'center', justifyContent:'center', padding:'40px 20px', minHeight:'100vh'}}>
      <div style={{background:'white', borderRadius:'16px', padding:'40px 36px', maxWidth:'460px', width:'100%', boxShadow:'0 4px 24px rgba(10,116,218,0.14)'}}>
        <div style={{textAlign:'center', marginBottom:'28px'}}>
          <div style={{fontSize:'13px', fontWeight:700, color:'#16a34a', letterSpacing:'1.5px', textTransform:'uppercase', marginBottom:'10px'}}>
            ✓ {completedSection} bölməsi tamamlandı
          </div>
          <h2 style={{fontSize:'24px', fontWeight:700, color:'#0c1f4a', marginBottom:'12px', letterSpacing:'-0.5px'}}>Daxil olun və davam edin</h2>
          <p style={{fontSize:'15px', color:'#6b7280', lineHeight:1.6}}>
            Növbəti <strong style={{color:'#0a74da'}}>{remaining} nümunə</strong> üçün ödənişsiz hesab açın
          </p>
        </div>

        <form onSubmit={handle}>
          {mode === 'register' && <input className="input" placeholder="Ad" value={firstName} onChange={e => setFirstName(e.target.value)} required />}
          {mode === 'register' && <input className="input" placeholder="Soyad" value={lastName} onChange={e => setLastName(e.target.value)} required />}
          <input className="input" type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required />
          <input className="input" type="password" placeholder="Şifrə (min. 6 simvol)" value={password} onChange={e => setPassword(e.target.value)} required minLength={6} />
          {error && <div className="error-msg">{error}</div>}
          <button className="btn-primary btn-lg" style={{width:'100%', marginTop:'4px'}} type="submit" disabled={loading}>
            {loading ? 'Yüklənir...' : mode === 'login' ? 'Daxil ol və davam et' : 'Qeydiyyatdan keç və davam et'}
          </button>
        </form>

        <div className="auth-switch" style={{marginTop:'20px', fontSize:'14px'}}>
          {mode === 'login'
            ? <>Hesabınız yoxdur? <span onClick={() => setMode('register')}>Qeydiyyat</span></>
            : <>Hesabınız var? <span onClick={() => setMode('login')}>Daxil ol</span></>}
        </div>

        <button className="btn-ghost" style={{marginTop:'18px', width:'100%'}} onClick={onCancel}>
          Sonra davam edərəm
        </button>
      </div>
    </div>
  )
}

// ─── RESULTS ──────────────────────────────────────────────────────────────────

function Results({ results, onRetry, onSelectTest, onHome, onBackToCourse, onBackToLesson, onNextLesson, hasPurchased, onAuth, onBuy, user }) {
  const { questions, answers, score, maxScore, timeSpent, topic, testNum, hintsUsed = 0, label, isQuiz, quizCourse, quizLesson, quizMock } = results
  const quizOwns = isQuiz && quizCourse ? hasPurchased(quizCourse) : false
  const [tab, setTab] = useState('all')
  const pct = Math.round((score / maxScore) * 100)
  const attempted = questions.filter(q => answers[q.id]).length
  const verdict = attempted === 0
    ? 'Suallara cavab vermədiniz'
    : pct >= 85 ? 'Əla nəticə! 🎉'
    : pct >= 70 ? 'Yaxşı nəticə 👍'
    : pct >= 50 ? 'Daha çox məşq lazımdır 💪'
    : 'Hazırlığa ehtiyac var 📚'
  const fmt = (s) => `${Math.floor(s/60)}:${(s%60).toString().padStart(2,'0')}`
  const wrong   = questions.filter(q => answers[q.id] != null && !isFullyCorrect(q, answers[q.id]))
  const skipped = questions.filter(q => answers[q.id] == null)
  const correct = questions.filter(q => isFullyCorrect(q, answers[q.id]))
  const isMix = topic === 'mix'
  const topicLabel = label ? label : (isMix ? 'Yüksəliş Müsabiqəsi - Analitik Təhlil imtahanı' : (TOPICS[topic]?.label || topic))
  const testLabel  = isQuiz
    ? (quizMock ? `Test ${quizMock}` : `Dərs ${quizLesson} Quizi`)
    : (isMix ? 'Nümunə testin nəticəsi' : (testNum > 0 ? `Test ${testNum}` : 'Ödənişsiz nümunə'))

  const isFreeSample = isMix || (testNum === 0 && !hasPurchased(topic))
  const showConversion = isFreeSample && !isQuiz
  const conversionMsg = pct >= 80
    ? 'Əla başlanğıc! Real testlərdə də bu sürətdə davam edə bilərsinizmi?'
    : 'Real hazırlıq Tam Paketdə · Detallı izahlar və 225 sual Sizi gözləyir.'

  const buyBundle = () => {
    if (user) onBuy('bundle')
    else onAuth()
  }

  return (
    <div className="results-page">
      <div className="test-topbar" style={{justifyContent:'center'}}>
        <Logo onClick={onHome} />
        <div style={{flex:1, textAlign:'center'}}>
          <div style={{fontSize:'12px', color:'#6b7280', fontWeight:600, letterSpacing:'1px', textTransform:'uppercase'}}>{topicLabel}</div>
          <div style={{fontSize:'15px', color:'#0c1f4a', fontWeight:600, marginTop:'2px'}}>{testLabel}</div>
        </div>
        <span style={{width:'150px'}} />
      </div>
      <div className="results-hero">
        <div className="results-label">Ümumi nəticəniz</div>
        <div className="results-score">
          {Number.isInteger(score) ? score : Math.round(score * 10) / 10}<span style={{color:'#9ca3af', fontWeight:600, fontSize:'0.4em', marginLeft:'4px'}}>/ {maxScore} bal</span>
        </div>
        <div className="results-pct-bar"><div style={{ width: `${pct}%` }} /></div>
        <span className="verdict-badge">{verdict}</span>
        {hintsUsed > 0 && (
          <div style={{
            background:'#fef3c7',
            border:'1px solid #fde68a',
            borderRadius:'10px',
            padding:'10px 16px',
            margin:'14px auto 0',
            maxWidth:'480px',
            fontSize:'13px',
            color:'#92400e',
            textAlign:'center',
            lineHeight:1.55,
          }}>
            💡 Bu testdə <strong>{hintsUsed} ipucundan</strong> istifadə etdiniz. Real imtahanda ipucu olmadığını nəzərə alın.
          </div>
        )}
      </div>
      {isMix && (
        <div style={{background:'white', padding:'28px 24px', borderBottom:'1px solid #d1e4f7'}}>
          <h3 style={{fontSize:'13px', color:'#6b7280', fontWeight:600, letterSpacing:'1.5px', textTransform:'uppercase', marginBottom:'18px', textAlign:'center'}}>
            Bölmələr üzrə nəticələr
          </h3>
          <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(190px, 1fr))', gap:'14px', maxWidth:'680px', margin:'0 auto'}}>
            {[
              { key:'verbal',   name:'Verbal Təhlil' },
              { key:'reqemsal', name:'Rəqəmsal Təhlil' },
              { key:'abstrakt', name:'Abstrakt Təhlil' },
            ].map(({ key, name }) => {
              const secQs = questions.filter(q => q.topic === key)
              const secCorrect = secQs.filter(q => isFullyCorrect(q, answers[q.id])).length
              const secAttempted = secQs.filter(q => answers[q.id]).length
              const secTotal = secQs.length
              const secPct = secTotal > 0 ? (secCorrect / secTotal) * 100 : 0
              const barColor = secAttempted === 0 ? '#d1d5db' : secPct >= 70 ? '#16a34a' : secPct >= 50 ? '#d97706' : '#dc2626'
              const barWidth = secAttempted === 0 ? 100 : secPct
              return (
                <div key={key} style={{background:'#f9fbff', border:'1.5px solid #d1e4f7', borderRadius:'12px', padding:'18px 14px', textAlign:'center'}}>
                  <div style={{fontSize:'13px', color:'#6b7280', fontWeight:600, marginBottom:'10px'}}>{name}</div>
                  <div style={{fontSize:'26px', fontWeight:800, color:'#0c1f4a', letterSpacing:'-0.5px', lineHeight:1}}>
                    {secCorrect}<span style={{fontSize:'15px', color:'#9ca3af', fontWeight:600}}>/{secTotal}</span>
                  </div>
                  <div style={{height:'5px', background:'#e5e7eb', borderRadius:'3px', marginTop:'12px', overflow:'hidden'}}>
                    <div style={{height:'100%', borderRadius:'3px', width:`${barWidth}%`, background:barColor, transition:'width 0.6s'}}></div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      )}
      <div className="results-stats">
        <div className="rstat"><div className="rstat-num good">{correct.length}</div><div className="rstat-label">Düzgün</div></div>
        <div className="rstat"><div className="rstat-num bad">{wrong.length}</div><div className="rstat-label">Yanlış</div></div>
        <div className="rstat"><div className="rstat-num warn">{skipped.length}</div><div className="rstat-label">Boş</div></div>
        <div className="rstat"><div className="rstat-num">{fmt(timeSpent)}</div><div className="rstat-label">Vaxt</div></div>
      </div>

      {!isMix && hasPurchased(topic) && (
        <div className="other-tests" style={{maxWidth:'760px', margin:'0 auto', padding:'24px', boxSizing:'border-box'}}>
          <span className="other-tests-label">Digər testlər:</span>
          {[1,2,3].map(t => (
            <button key={t} className={t === testNum ? 'btn-test-active' : 'btn-outline'} onClick={() => t !== testNum && onSelectTest(t)}>
              Test {t}{t === testNum ? ' ✓' : ''}
            </button>
          ))}
        </div>
      )}
      <div className="results-body" style={{maxWidth:'760px', margin:'0 auto', padding:'0 24px', boxSizing:'border-box'}}>
        <div className="rtabs">
          <button className={`rtab ${tab==='wrong'?'active':''}`}   onClick={() => setTab('wrong')}>Yanlış ({wrong.length})</button>
          <button className={`rtab ${tab==='skipped'?'active':''}`} onClick={() => setTab('skipped')}>Boş ({skipped.length})</button>
          <button className={`rtab ${tab==='all'?'active':''}`}     onClick={() => setTab('all')}>Hamısı ({questions.length})</button>
        </div>
        <div className="review-list">
          {(tab==='wrong' ? wrong : tab==='skipped' ? skipped : questions).map(q => (
            <ReviewItem key={q.id} q={q} userAnswer={answers[q.id]} />
          ))}
          {tab === 'wrong' && wrong.length === 0 && (
            <div className="empty-state">
              {skipped.length === 0 ? 'Hər şey düzgündür 🎉' : 'Yanlış cavabınız yoxdur'}
            </div>
          )}
          {tab === 'skipped' && skipped.length === 0 && (
            <div className="empty-state">Bütün suallara cavab verdiniz 🎉</div>
          )}
        </div>
      </div>

      {showConversion && (
        <div style={{padding:'32px 24px', textAlign:'center', background:'#f0f7ff', borderTop:'1px solid #d1e4f7'}}>
          <h3 style={{fontSize:'20px', fontWeight:700, color:'#0c1f4a', marginBottom:'8px'}}>Hazırsınız?</h3>
          <p style={{fontSize:'14px', color:'#4b5563', marginBottom:'18px'}}>Tək bölmə və ya tam paket, seçim sizindir</p>

          <div style={{display:'flex', flexWrap:'wrap', justifyContent:'center', gap:'10px', maxWidth:'620px', margin:'0 auto 18px'}}>
            {!hasPurchased('verbal') && (
              <button onClick={() => { user ? onBuy('verbal') : onAuth() }} style={{padding:'10px 18px', background:'white', color:'#0a74da', border:'1.5px solid #0a74da', borderRadius:'8px', fontSize:'14px', fontWeight:600, cursor:'pointer', fontFamily:'inherit'}}>
                Verbal Təhlil · ₼29
              </button>
            )}
            {!hasPurchased('reqemsal') && (
              <button onClick={() => { user ? onBuy('reqemsal') : onAuth() }} style={{padding:'10px 18px', background:'white', color:'#0a74da', border:'1.5px solid #0a74da', borderRadius:'8px', fontSize:'14px', fontWeight:600, cursor:'pointer', fontFamily:'inherit'}}>
                Rəqəmsal Təhlil · ₼29
              </button>
            )}
            {!hasPurchased('abstrakt') && (
              <button onClick={() => { user ? onBuy('abstrakt') : onAuth() }} style={{padding:'10px 18px', background:'white', color:'#0a74da', border:'1.5px solid #0a74da', borderRadius:'8px', fontSize:'14px', fontWeight:600, cursor:'pointer', fontFamily:'inherit'}}>
                Abstrakt Təhlil · ₼29
              </button>
            )}
          </div>

          <div style={{maxWidth:'380px', margin:'0 auto'}}>
            <button className="btn-primary btn-lg" onClick={buyBundle} style={{width:'100%'}}>Tam Paketi al · ₼59 →</button>
            <div style={{fontSize:'12px', color:'#6b7280', marginTop:'8px'}}>9 test · 225 sual · 2 ay · 28 ₼ qənaət</div>
          </div>
        </div>
      )}

      {isQuiz && !quizOwns && (
        <div style={{padding:'32px 24px', textAlign:'center', background:'#f0f7ff', borderTop:'1px solid #d1e4f7'}}>
          <h3 style={{fontSize:'20px', fontWeight:700, color:'#0c1f4a', marginBottom:'8px'}}>Proqrama davam edin</h3>
          <p style={{fontSize:'14px', color:'#4b5563', marginBottom:'18px'}}>İlk dərs ödənişsizdir. Növbəti materiallara davam etmək üçün proqramı əldə edin.</p>
          <div style={{maxWidth:'380px', margin:'0 auto', display:'flex', flexDirection:'column', gap:'10px'}}>
            <button className="btn-primary btn-lg" style={{width:'100%'}} onClick={() => { user ? onBuy('idareetme') : onAuth() }}>
              Tam paket: SMT + EZT · ₼59
            </button>
            <button className="btn-outline" style={{width:'100%', padding:'12px'}} onClick={() => { user ? onBuy(quizCourse) : onAuth() }}>
              Yalnız {quizCourse === 'ez' ? 'EZT' : 'SMT'} · ₼49
            </button>
          </div>
        </div>
      )}

      {isQuiz ? (
        <div className="results-actions" style={{flexWrap:'wrap'}}>
          {quizLesson && <button className="btn-ghost" onClick={onBackToLesson}>← Dərsə qayıt</button>}
          <button className="btn-ghost" onClick={onBackToCourse}>Proqrama qayıt</button>
          <button className="btn-outline" onClick={onRetry}>Yenidən cəhd et</button>
          {quizLesson && quizOwns && <button className="btn-primary" onClick={onNextLesson}>Növbəti dərs →</button>}
        </div>
      ) : (
        <div className="results-actions">
          <button className="btn-ghost" onClick={onHome}>Ana səhifə</button>
          <button className="btn-outline" onClick={onRetry}>Yenidən başla</button>
        </div>
      )}
    </div>
  )
}

function ReviewItem({ q, userAnswer }) {
  const [open, setOpen] = useState(false)
  const isCorrect = isFullyCorrect(q, userAnswer)
  const isSkipped = userAnswer == null
  const fmtAns = (val) => {
    if (val == null) return ''
    if (Array.isArray(val)) return val.map((k, i) => `${i + 1}. ${k}`).join('   ')
    if (typeof val === 'object') {
      if ('best' in val || 'worst' in val) {
        const parts = []
        if (val.best) parts.push(`Ən effektiv: ${val.best}`)
        if (val.worst) parts.push(`Ən az effektiv: ${val.worst}`)
        return parts.join('   ·   ')
      }
      return Object.keys(val).map(k => `${k}=${val[k]}`).join('   ')
    }
    return `${val}: ${q.options[val] || ''}`
  }
  const fmtKey = () => {
    const c = q.correct
    if (Array.isArray(c)) return c.map((k, i) => `${i + 1}. ${k}`).join('   ')
    if (c && typeof c === 'object') {
      if ('best' in c || 'worst' in c) {
        const parts = []
        if (c.best) parts.push(`Ən effektiv: ${c.best}`)
        if (c.worst) parts.push(`Ən az effektiv: ${c.worst}`)
        return parts.join('   ·   ')
      }
      return Object.keys(c).map(k => `${k}=${c[k]}`).join('   ')
    }
    return `${c}: ${q.options[c] || ''}`
  }
  return (
    <div className={`review-item ${isCorrect ? 'correct' : isSkipped ? 'skipped' : 'wrong'}`}>
      <div className="review-icon">{isCorrect ? '✓' : isSkipped ? '·' : '✗'}</div>
      <div className="review-content">
        {q.passage_text && (
          <div className="review-passage-toggle" onClick={() => setOpen(o => !o)}>
            📖 Mətni {open ? 'gizlət' : 'göstər'} ▾
          </div>
        )}
        {open && q.passage_text && <div className="passage-text review-passage">{q.passage_text}</div>}
        <div className="review-q">{q.question_az}</div>
        {q.table_data && <TableDisplay data={q.table_data} />}
        {q.chart_data && <ChartDisplay data={q.chart_data} />}
        {q.svg_question && <SvgDisplay svgContent={q.svg_question} />}
        <div className="review-answers">
          {!isSkipped && <span className={`ans-badge ${isCorrect ? 'ans-correct' : 'ans-wrong'}`}>Sizin cavabınız: {fmtAns(userAnswer)}</span>}
          {!isCorrect && <span className="ans-badge ans-right">Düzgün cavab: {fmtKey()}</span>}
          {isSkipped && (
            <span
              className="ans-badge ans-skip"
              style={{
                background: '#fef3c7',
                color: '#92400e',
                border: '1px solid #fde68a',
              }}
            >Boş</span>
          )}
        </div>
        <div className="review-explain">{q.explanation}</div>
      </div>
    </div>
  )
}

function SvgDisplay({ svgContent }) {
  return (
    <div style={{ overflowX: 'auto', margin: '12px 0' }}>
      <div style={{ maxWidth: '340px' }} dangerouslySetInnerHTML={{ __html: svgContent }} />
    </div>
  )
}

function TableDisplay({ data }) {
  return (
    <div className="table-wrap">
      <table className="data-table">
        <thead><tr>{data.headers.map((h, i) => <th key={i}>{h}</th>)}</tr></thead>
        <tbody>{data.rows.map((row, i) => <tr key={i}>{row.map((cell, j) => <td key={j}>{cell}</td>)}</tr>)}</tbody>
      </table>
    </div>
  )
}

function ChartDisplay({ data }) {
  const max = Math.max(...data.values)
  return (
    <div className="chart-wrap">
      <div className="chart-title">{data.title}</div>
      {data.labels.map((label, i) => (
        <div key={i} className="bar-row">
          <div className="bar-label">{label}</div>
          <div className="bar-track">
            <div className="bar-fill" style={{ width: `${(data.values[i]/max)*100}%`, background: data.color || '#0a74da' }}>
              <span className="bar-val">{data.values[i]}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

// ─── FOOTER ────────────────────────────────────────────────────────────────

function Footer({ navTo }) {
  return (
    <footer style={{background:'#0958a8', color:'#e0ecf9', marginTop:'auto'}}>
      <div style={{maxWidth:'1120px', margin:'0 auto', padding:'48px 32px 18px'}}>
        <div style={{display:'grid', gridTemplateColumns:'1.4fr 1fr 1.2fr', gap:'40px', marginBottom:'32px'}} className="footer-grid">
          {/* Column 1 - Brand */}
          <div>
            <div style={{display:'flex', alignItems:'center', gap:'14px', marginBottom:'14px'}}>
              <div style={{width:'38px', height:'38px', borderRadius:'50%', background:'white', overflow:'hidden', flexShrink:0}}>
                <svg width="38" height="38" viewBox="0 0 52 52" style={{display:'block'}}>
                  <g transform="rotate(15,26,26)">
                    <rect x="13" y="2" width="6" height="48" rx="3" fill="#0a74da"/>
                    <rect x="33" y="2" width="6" height="48" rx="3" fill="#0a74da"/>
                    <rect x="13" y="8" width="26" height="5" rx="2.5" fill="#0a74da"/>
                    <rect x="13" y="21" width="26" height="5" rx="2.5" fill="#0a74da"/>
                    <rect x="13" y="34" width="26" height="5" rx="2.5" fill="#0a74da"/>
                  </g>
                </svg>
              </div>
              <div style={{display:'flex', flexDirection:'column', lineHeight:1}}>
                <span style={{fontSize:'20px', fontWeight:700, color:'white', letterSpacing:'-0.5px'}}>pillə</span>
                <span style={{fontSize:'9px', color:'#a3c5e8', textTransform:'uppercase', letterSpacing:'1.5px', marginTop:'4px', fontWeight:600}}>təhsil platforması</span>
              </div>
            </div>
            <p style={{fontSize:'13px', color:'#cbe0f5', lineHeight:1.6}}></p>
          </div>

          {/* Column 2 - Imtahanlar */}
          <div>
            <h4 style={{fontSize:'11px', color:'#a3c5e8', textTransform:'uppercase', letterSpacing:'1.5px', fontWeight:700, marginBottom:'14px'}}>İmtahanlar</h4>
            <a onClick={() => navTo(PAGES.YUKSELISH)} style={{display:'block', fontSize:'14px', color:'#e0ecf9', textDecoration:'none', marginBottom:'9px', cursor:'pointer'}}>Yüksəliş</a>
            <span style={{display:'block', fontSize:'14px', color:'#a3c5e8', marginBottom:'9px'}}>Dövlət Qulluğu <span style={{color:'#7ba9d9', fontSize:'12px'}}>(tezliklə)</span></span>
            <span style={{display:'block', fontSize:'14px', color:'#a3c5e8', marginBottom:'9px'}}>Bakalavriat <span style={{color:'#7ba9d9', fontSize:'12px'}}>(tezliklə)</span></span>
            <span style={{display:'block', fontSize:'14px', color:'#a3c5e8'}}>Magistratura <span style={{color:'#7ba9d9', fontSize:'12px'}}>(tezliklə)</span></span>
          </div>

          {/* Column 3 - flat links */}
          <div>
            <a onClick={() => navTo(PAGES.HAQQIMIZDA)} style={{display:'block', fontSize:'14px', color:'#e0ecf9', textDecoration:'none', marginBottom:'9px', cursor:'pointer'}}>Haqqımızda</a>
            <a onClick={() => navTo(PAGES.CONTACT)} style={{display:'block', fontSize:'14px', color:'#e0ecf9', textDecoration:'none', marginBottom:'9px', cursor:'pointer'}}>Əlaqə</a>
            <a onClick={() => navTo(PAGES.FAQ)} style={{display:'block', fontSize:'14px', color:'#e0ecf9', textDecoration:'none', marginBottom:'9px', cursor:'pointer'}}>Tez-tez verilən suallar</a>
            <a onClick={() => navTo(PAGES.TERMS)} style={{display:'block', fontSize:'14px', color:'#e0ecf9', textDecoration:'none', marginBottom:'9px', cursor:'pointer'}}>İstifadə qaydaları</a>
            <a onClick={() => navTo(PAGES.PRIVACY)} style={{display:'block', fontSize:'14px', color:'#e0ecf9', textDecoration:'none', cursor:'pointer'}}>Gizlilik siyasəti</a>
          </div>
        </div>

        <div style={{borderTop:'1px solid #1e6dba', paddingTop:'18px', display:'flex', justifyContent:'space-between', alignItems:'center', fontSize:'12.5px', color:'#a3c5e8', flexWrap:'wrap', gap:'10px'}}>
          <span>© 2026 pillə</span>
          <div style={{display:'flex', gap:'10px'}}>
            <a href="https://instagram.com/pilleapp" target="_blank" rel="noopener noreferrer" title="Instagram" style={{width:'34px', height:'34px', border:'1px solid #1e6dba', borderRadius:'8px', display:'flex', alignItems:'center', justifyContent:'center', color:'#cbe0f5', textDecoration:'none'}}>
              <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.22.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.22.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.22-.06-1.27-.07-1.65-.07-4.85s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.22-.41C8.42 2.17 8.8 2.16 12 2.16zM12 0C8.74 0 8.33.01 7.05.07 5.77.13 4.9.33 4.14.63a5.85 5.85 0 0 0-2.13 1.38A5.85 5.85 0 0 0 .63 4.14C.33 4.9.13 5.77.07 7.05.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.28.26 2.15.56 2.91.31.79.73 1.46 1.38 2.13.66.66 1.34 1.07 2.13 1.38.76.3 1.63.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.28-.06 2.15-.26 2.91-.56a5.86 5.86 0 0 0 2.13-1.38c.66-.66 1.07-1.34 1.38-2.13.3-.76.5-1.63.56-2.91C23.99 15.67 24 15.26 24 12s-.01-3.67-.07-4.95c-.06-1.28-.26-2.15-.56-2.91A5.86 5.86 0 0 0 21.99 2c-.66-.66-1.34-1.07-2.13-1.38C19.1.33 18.23.13 16.95.07 15.67.01 15.26 0 12 0zm0 5.84a6.16 6.16 0 1 0 0 12.32 6.16 6.16 0 0 0 0-12.32zm0 10.16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm7.84-10.4a1.44 1.44 0 1 1-2.88 0 1.44 1.44 0 0 1 2.88 0z"/></svg>
            </a>
          </div>
        </div>
      </div>
      <div style={{background:'#074593', color:'#a3c5e8', padding:'14px 32px', textAlign:'center', fontSize:'12px', lineHeight:1.55}}>
        pillə müstəqil təhsil platformasıdır və heç bir qurum ilə əlaqəli deyil
      </div>
    </footer>
  )
}

// ─── HAQQIMIZDA PAGE (NEW) ────────────────────────────────────────────────

function HaqqimizdaPage({ onHome, user, onNav, onDashboard, onAuth }) {
  return (
    <div style={{minHeight:'calc(100vh - 200px)', background:'white'}}>
      <SiteNav
        user={user}
        onLogo={onHome}
        onNav={onNav}
        onAuth={onAuth}
        onDashboard={onDashboard}
        currentPage={PAGES.HAQQIMIZDA}
      />
      <div style={{maxWidth:'720px', margin:'0 auto', padding:'56px 24px 80px'}}>
        <h1 style={{fontSize:'36px', fontWeight:700, color:'#0c1f4a', letterSpacing:'-0.5px', marginBottom:'32px', textAlign:'center'}}>
          Haqqımızda
        </h1>
        <p style={{fontSize:'17px', color:'#374151', lineHeight:1.75, marginBottom:'20px'}}>
          <span style={{color:'#0a74da', fontWeight:600}}>pillə</span> imtahanlara onlayn hazırlıq platformasıdır. Karyera və təhsil yolunuzdakı növbəti pilləyə çatmaq üçün real imtahan formatında suallar, ətraflı izahlar və hazırlıq vasitələri təqdim edirik.
        </p>
        <p style={{fontSize:'17px', color:'#374151', lineHeight:1.75}}>
          Məqsədimiz hər kəsin keyfiyyətli imtahan hazırlığına çıxış əldə etməsidir.
        </p>
      </div>
    </div>
  )
}

// ─── CONTACT PAGE (REWRITTEN: form + email + Instagram + FAQ) ─────────────

function ContactPage({ onHome, user, onNav, onDashboard, onAuth }) {
  const [submitting, setSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSubmitting(true)
    setError('')
    const formData = new FormData(e.target)
    try {
      const response = await fetch('https://formspree.io/f/xvzlywjz', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      })
      if (response.ok) {
        setSubmitted(true)
        e.target.reset()
      } else {
        setError('Mesaj göndərilə bilmədi. Yenidən cəhd edin.')
      }
    } catch (err) {
      setError('Şəbəkə xətası. Yenidən cəhd edin.')
    }
    setSubmitting(false)
  }

  return (
    <div style={{minHeight:'calc(100vh - 200px)', background:'white'}}>
      <SiteNav
        user={user}
        onLogo={onHome}
        onNav={onNav}
        onAuth={onAuth}
        onDashboard={onDashboard}
        currentPage={PAGES.CONTACT}
      />
      <div style={{maxWidth:'720px', margin:'0 auto', padding:'56px 24px 80px'}}>
        <div style={{textAlign:'center', marginBottom:'40px'}}>
          <h1 style={{fontSize:'36px', fontWeight:700, color:'#0c1f4a', letterSpacing:'-0.5px', marginBottom:'12px'}}>Əlaqə</h1>
          <p style={{fontSize:'17px', color:'#6b7280', maxWidth:'520px', margin:'0 auto', lineHeight:1.6}}>
            Sual, rəy və ya əməkdaşlıq üçün bizə yazın.
          </p>
        </div>

        {/* Form */}
        <div style={{background:'white', border:'1.5px solid #d1e4f7', borderRadius:'14px', padding:'28px', marginBottom:'20px'}}>
          {submitted ? (
            <div style={{textAlign:'center', padding:'20px 0'}}>
              <div style={{fontSize:'40px', marginBottom:'8px', color:'#16a34a'}}>✓</div>
              <h3 style={{fontSize:'20px', fontWeight:700, color:'#0c1f4a', marginBottom:'6px'}}>Mesajınız göndərildi</h3>
              <p style={{fontSize:'14px', color:'#6b7280'}}>Tezliklə cavab verəcəyik.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <input className="input" name="name" placeholder="Ad" required />
              <input className="input" type="email" name="email" placeholder="E-mail" required />
              <textarea
                className="input"
                name="message"
                placeholder="Mesajınız"
                rows={5}
                required
                style={{resize:'vertical', minHeight:'120px', fontFamily:'inherit'}}
              ></textarea>
              {error && <div className="error-msg">{error}</div>}
              <button className="btn-primary btn-full" type="submit" disabled={submitting}>
                {submitting ? 'Göndərilir...' : 'Göndər'}
              </button>
            </form>
          )}
        </div>

        {/* Direct contact: Email + Instagram */}
        <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(240px, 1fr))', gap:'14px', marginBottom:'56px'}}>
          <a href="mailto:support@pille.az" style={{display:'flex', alignItems:'center', gap:'12px', padding:'18px 20px', border:'1.5px solid #d1e4f7', borderRadius:'12px', textDecoration:'none', background:'white'}}>
            <div style={{width:'40px', height:'40px', borderRadius:'10px', background:'#0a74da', color:'white', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0}}>
              <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 8l9 6 9-6M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
            </div>
            <div style={{minWidth:0}}>
              <div style={{fontSize:'12px', color:'#6b7280', marginBottom:'2px', textTransform:'uppercase', letterSpacing:'0.5px'}}>E-mail</div>
              <div style={{fontSize:'14px', color:'#0c1f4a', fontWeight:600, overflow:'hidden', textOverflow:'ellipsis'}}>support@pille.az</div>
            </div>
          </a>
          <a href="https://instagram.com/pilleapp" target="_blank" rel="noopener noreferrer" style={{display:'flex', alignItems:'center', gap:'12px', padding:'18px 20px', border:'1.5px solid #d1e4f7', borderRadius:'12px', textDecoration:'none', background:'white'}}>
            <div style={{width:'40px', height:'40px', borderRadius:'10px', background:'#0a74da', color:'white', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0}}>
              <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.22.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.22.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.22-.06-1.27-.07-1.65-.07-4.85s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.22-.41C8.42 2.17 8.8 2.16 12 2.16zM12 0C8.74 0 8.33.01 7.05.07 5.77.13 4.9.33 4.14.63a5.85 5.85 0 0 0-2.13 1.38A5.85 5.85 0 0 0 .63 4.14C.33 4.9.13 5.77.07 7.05.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.28.26 2.15.56 2.91.31.79.73 1.46 1.38 2.13.66.66 1.34 1.07 2.13 1.38.76.3 1.63.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.28-.06 2.15-.26 2.91-.56a5.86 5.86 0 0 0 2.13-1.38c.66-.66 1.07-1.34 1.38-2.13.3-.76.5-1.63.56-2.91C23.99 15.67 24 15.26 24 12s-.01-3.67-.07-4.95c-.06-1.28-.26-2.15-.56-2.91A5.86 5.86 0 0 0 21.99 2c-.66-.66-1.34-1.07-2.13-1.38C19.1.33 18.23.13 16.95.07 15.67.01 15.26 0 12 0zm0 5.84a6.16 6.16 0 1 0 0 12.32 6.16 6.16 0 0 0 0-12.32zm0 10.16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm7.84-10.4a1.44 1.44 0 1 1-2.88 0 1.44 1.44 0 0 1 2.88 0z"/></svg>
            </div>
            <div style={{minWidth:0}}>
              <div style={{fontSize:'12px', color:'#6b7280', marginBottom:'2px', textTransform:'uppercase', letterSpacing:'0.5px'}}>Instagram</div>
              <div style={{fontSize:'14px', color:'#0c1f4a', fontWeight:600, overflow:'hidden', textOverflow:'ellipsis'}}>@pilleapp</div>
            </div>
          </a>
        </div>

      </div>
    </div>
  )
}

// ─── TERMS PAGE ────────────────────────────────────────────────────────────

function TermsPage({ onHome, user }) {
  return (
    <div style={{minHeight:'calc(100vh - 200px)', background:'white'}}>
      <nav className="nav">
        <Logo onClick={onHome} />
        <div className="nav-links"></div>
        <div className="nav-actions">
          {user
            ? <span className="user-email">{user.email}</span>
            : <button className="btn-ghost" onClick={onHome}>← Ana səhifə</button>}
        </div>
      </nav>
      <div style={{maxWidth:'760px', margin:'0 auto', padding:'56px 24px 80px'}}>
        <h1 style={{fontSize:'32px', fontWeight:700, color:'#0c1f4a', letterSpacing:'-0.5px', marginBottom:'8px'}}>İstifadə qaydaları</h1>
        <p style={{fontSize:'13px', color:'#9ca3af', marginBottom:'40px'}}>Son yenilənmə: 13 May 2026</p>

        <div style={{fontSize:'15px', color:'#4b5563', lineHeight:1.75}}>
          <h2 style={{fontSize:'19px', fontWeight:700, color:'#0c1f4a', marginTop:'32px', marginBottom:'12px'}}>1. Platforma haqqında</h2>
          <p style={{marginBottom:'14px'}}>pillə müstəqil təhsil platformasıdır. Sayt heç bir dövlət qurumu, müsabiqə təşkilatçısı və ya rəsmi imtahan mərkəzi ilə əlaqəli deyil.</p>

          <h2 style={{fontSize:'19px', fontWeight:700, color:'#0c1f4a', marginTop:'32px', marginBottom:'12px'}}>2. İmtahan və müsabiqə adları haqqında</h2>
          <p style={{marginBottom:'14px'}}>Saytda istifadə olunan imtahan və müsabiqə adları yalnız təsviri məqsədlərlə, istifadəçilərə hansı imtahana hazırlaşdıqlarını izah etmək üçün, istifadə olunur.</p>

          <h2 style={{fontSize:'19px', fontWeight:700, color:'#0c1f4a', marginTop:'32px', marginBottom:'12px'}}>3. Materialların məqsədi</h2>
          <p style={{marginBottom:'14px'}}>Saytdakı bütün testlər və izahlar tədris və hazırlıq məqsədilədir. Real imtahanların məzmunu və formatı dəyişə bilər. pillə nəticələrə zəmanət vermir.</p>
          <p style={{marginBottom:'14px'}}>İstifadəçi platformadan əldə etdiyi materialları yalnız öz şəxsi hazırlığı üçün istifadə edə bilər. Materialların yenidən satılması, paylaşılması və ya kopyalanması qadağandır.</p>

          <h2 style={{fontSize:'19px', fontWeight:700, color:'#0c1f4a', marginTop:'32px', marginBottom:'12px'}}>4. Ödəniş və geri qaytarma</h2>
          <p style={{marginBottom:'14px'}}>Alış-veriş birdəfəlik ödənişdir və təhlükəsiz ödəniş sistemi vasitəsilə həyata keçirilir. Aldığınız bölmələrə 2 ay limitsiz giriş əldə edirsiniz.</p>
          <p style={{marginBottom:'14px'}}>Texniki səbəblərdən giriş əldə edə bilmədikdə 7 gün ərzində support@pille.az ünvanı ilə əlaqə saxlayın və ödəniş geri qaytarılacaq.</p>

          <h2 style={{fontSize:'19px', fontWeight:700, color:'#0c1f4a', marginTop:'32px', marginBottom:'12px'}}>5. Hesab və təhlükəsizlik</h2>
          <p style={{marginBottom:'14px'}}>Hesab məlumatlarınızın təhlükəsizliyi sizin məsuliyyətinizdədir. Şifrənizi heç kimlə paylaşmayın. Hesab paylaşılması aşkar edildikdə pillə hesabı bağlamaq hüququnu özündə saxlayır.</p>

          <h2 style={{fontSize:'19px', fontWeight:700, color:'#0c1f4a', marginTop:'32px', marginBottom:'12px'}}>6. Dəyişikliklər</h2>
          <p style={{marginBottom:'14px'}}>Bu qaydalar lazım gəldikdə yenilənə bilər. Əhəmiyyətli dəyişikliklər istifadəçilərə email vasitəsilə bildirilir.</p>
        </div>
      </div>
    </div>
  )
}

// ─── PRIVACY PAGE ──────────────────────────────────────────────────────────

function PrivacyPage({ onHome, user }) {
  return (
    <div style={{minHeight:'calc(100vh - 200px)', background:'white'}}>
      <nav className="nav">
        <Logo onClick={onHome} />
        <div className="nav-links"></div>
        <div className="nav-actions">
          {user
            ? <span className="user-email">{user.email}</span>
            : <button className="btn-ghost" onClick={onHome}>← Ana səhifə</button>}
        </div>
      </nav>
      <div style={{maxWidth:'760px', margin:'0 auto', padding:'56px 24px 80px'}}>
        <h1 style={{fontSize:'32px', fontWeight:700, color:'#0c1f4a', letterSpacing:'-0.5px', marginBottom:'8px'}}>Gizlilik siyasəti</h1>
        <p style={{fontSize:'13px', color:'#9ca3af', marginBottom:'40px'}}>Son yenilənmə: 13 May 2026</p>

        <div style={{fontSize:'15px', color:'#4b5563', lineHeight:1.75}}>
          <h2 style={{fontSize:'19px', fontWeight:700, color:'#0c1f4a', marginTop:'32px', marginBottom:'12px'}}>1. Topladığımız məlumatlar</h2>
          <p style={{marginBottom:'14px'}}>Qeydiyyat zamanı email ünvanınızı və adınızı toplayırıq. Test cavablarınız və nəticələriniz hesabınızla əlaqələndirilir.</p>

          <h2 style={{fontSize:'19px', fontWeight:700, color:'#0c1f4a', marginTop:'32px', marginBottom:'12px'}}>2. Məlumatların saxlanması</h2>
          <p style={{marginBottom:'14px'}}>Bütün məlumatlar etibarlı bulud xidməti üzərində şifrələnmiş şəkildə saxlanılır. Şifrələriniz bizdə açıq şəkildə saxlanılmır.</p>

          <h2 style={{fontSize:'19px', fontWeight:700, color:'#0c1f4a', marginTop:'32px', marginBottom:'12px'}}>3. Ödəniş məlumatları</h2>
          <p style={{marginBottom:'14px'}}>Bank kartı məlumatları bizdə saxlanılmır. Bütün ödənişlər təhlükəsiz ödəniş sistemi vasitəsilə həyata keçirilir.</p>

          <h2 style={{fontSize:'19px', fontWeight:700, color:'#0c1f4a', marginTop:'32px', marginBottom:'12px'}}>4. Çərəzlər (Cookies)</h2>
          <p style={{marginBottom:'14px'}}>Sayt yalnız texniki çərəzlərdən istifadə edir, istifadəçi sessiyasını və hesab girişini saxlamaq üçün. Reklam və ya izləmə çərəzləri istifadə etmirik.</p>

          <h2 style={{fontSize:'19px', fontWeight:700, color:'#0c1f4a', marginTop:'32px', marginBottom:'12px'}}>5. Sizin hüquqlarınız</h2>
          <p style={{marginBottom:'14px'}}>Hesabınızı silmək və ya məlumatlarınıza giriş/düzəliş etmək üçün support@pille.az ünvanı ilə əlaqə saxlayın.</p>

          <h2 style={{fontSize:'19px', fontWeight:700, color:'#0c1f4a', marginTop:'32px', marginBottom:'12px'}}>6. Üçüncü tərəflərlə paylaşım</h2>
          <p style={{marginBottom:'14px'}}>Şəxsi məlumatlarınızı satmırıq və marketinq məqsədilə üçüncü tərəflərə vermirik.</p>
        </div>
      </div>
    </div>
  )
}

// ─── FAQ PAGE (Tez-tez verilən suallar) ───────────────────────────────────

function FaqPage({ onHome, user, onNav, onDashboard, onAuth }) {
  return (
    <div style={{minHeight:'calc(100vh - 200px)', background:'white'}}>
      <SiteNav
        user={user}
        onLogo={onHome}
        onNav={onNav}
        onAuth={onAuth}
        onDashboard={onDashboard}
        currentPage={PAGES.FAQ}
      />
      <div style={{maxWidth:'720px', margin:'0 auto', padding:'56px 24px 80px'}}>
        <h1 style={{fontSize:'36px', fontWeight:700, color:'#0c1f4a', letterSpacing:'-0.5px', marginBottom:'32px', textAlign:'center'}}>
          Tez-tez verilən suallar
        </h1>
        <div>
          {[
            { q: 'Ödəniş necə işləyir?', a: 'Bank kartı (Visa/Mastercard) ilə bir dəfəlik ödəniş edirsiniz. Beynəlxalq ödəniş aktivləşdirilmiş kart lazımdır. Birbank, m10 və ABB Mobile tətbiqlərində bunu aktivləşdirə bilərsiniz.' },
            { q: 'Aldıqdan sonra nə qədər müddətə girişim olacaq?', a: 'Aldığınız bölmələrə 2 ay limitsiz giriş var. Bu müddət ərzində bütün testləri istənilən qədər dəfə edə bilərsiniz.' },
            { q: 'Geri qaytarma siyasəti necədir?', a: 'Texniki problem olduğu halda 7 gün ərzində geri qaytarma mümkündür. support@pille.az ünvanına yazın.' },
            { q: 'Hesabımdan ödəniş çıxıb amma giriş əldə edə bilmirəm', a: 'Belə hallarda dərhal support@pille.az ünvanına ödəniş təsdiqi ilə yazın. Tez bir zamanda hesabınızı aktivləşdirəcəyik.' },
            { q: 'Şifrəmi unutmuşam, necə bərpa edim?', a: 'Daxil olma səhifəsindən "Şifrəni unutdum?" düyməsinə klikləyin. Email-inizi daxil edin, yeniləmə linkini sizə göndərəcəyik.' },
            { q: 'Hansı email-lə qeydiyyatdan keçdiyimi unutmuşam, necə tapım?', a: 'support@pille.az ünvanına ad-soyad və ödəniş məlumatlarınızla yazın. Hesabınızı tapıb sizə cavab verəcəyik.' },
          ].map((item, i) => (
            <div key={i} style={{padding:'22px 0', borderBottom:'1px solid #f3f4f6'}}>
              <div style={{fontSize:'17px', fontWeight:600, color:'#0c1f4a', marginBottom:'10px'}}>{item.q}</div>
              <div style={{fontSize:'15px', color:'#4b5563', lineHeight:1.7}}>{item.a}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
// ─── MARKDOWN RENDERER (lessons) ──────────────────────────────────────────

function MdInline({ text }) {
  // Split on **bold**
  const parts = String(text).split(/(\*\*[^*]+\*\*)/g)
  return (
    <>
      {parts.map((p, i) => {
        if (p.startsWith('**') && p.endsWith('**')) {
          return <strong key={i} style={{fontWeight:600, color:'#0c1f4a'}}>{p.slice(2, -2)}</strong>
        }
        return <React.Fragment key={i}>{p}</React.Fragment>
      })}
    </>
  )
}

function Markdown({ text }) {
  if (!text) return null
  const lines = String(text).replace(/\r\n/g, '\n').split('\n')
  const blocks = []
  let para = []
  let list = []

  const flushPara = () => {
    if (para.length) {
      blocks.push({ type: 'p', text: para.join(' ') })
      para = []
    }
  }
  const flushList = () => {
    if (list.length) {
      blocks.push({ type: 'ul', items: [...list] })
      list = []
    }
  }

  for (let raw of lines) {
    const line = raw.trim()
    if (line === '') { flushPara(); flushList(); continue }
    if (line === '---' || line === '***') { flushPara(); flushList(); blocks.push({ type: 'hr' }); continue }
    if (line.startsWith('### ')) { flushPara(); flushList(); blocks.push({ type: 'h3', text: line.slice(4) }); continue }
    if (line.startsWith('## ')) { flushPara(); flushList(); blocks.push({ type: 'h2', text: line.slice(3) }); continue }
    if (line.startsWith('# ')) { flushPara(); flushList(); blocks.push({ type: 'h2', text: line.slice(2) }); continue }
    if (line.startsWith('<svg')) { flushPara(); flushList(); blocks.push({ type: 'svg', html: line }); continue }
    if (line.startsWith('- ') || line.startsWith('* ')) { flushPara(); list.push(line.slice(2)); continue }
    flushList()
    para.push(line)
  }
  flushPara(); flushList()

  return (
    <div>
      {blocks.map((b, i) => {
        if (b.type === 'h2') return <h2 key={i} style={{fontSize:'20px', fontWeight:700, color:'#0c1f4a', margin:'28px 0 12px', letterSpacing:'-0.3px'}}><MdInline text={b.text} /></h2>
        if (b.type === 'h3') return <h3 key={i} style={{fontSize:'16px', fontWeight:700, color:'#0c1f4a', margin:'22px 0 8px'}}><MdInline text={b.text} /></h3>
        if (b.type === 'hr') return <hr key={i} style={{border:'none', borderTop:'1px solid #e5e7eb', margin:'24px 0'}} />
        if (b.type === 'svg') return <div key={i} style={{display:'flex', justifyContent:'center', margin:'18px 0'}} dangerouslySetInnerHTML={{ __html: b.html }} />
        if (b.type === 'ul') return (
          <ul key={i} style={{margin:'12px 0', paddingLeft:'22px'}}>
            {b.items.map((it, j) => <li key={j} style={{fontSize:'15px', color:'#374151', lineHeight:1.7, marginBottom:'6px'}}><MdInline text={it} /></li>)}
          </ul>
        )
        return <p key={i} style={{fontSize:'15px', color:'#374151', lineHeight:1.75, margin:'0 0 14px'}}><MdInline text={b.text} /></p>
      })}
    </div>
  )
}

// ─── YÜKSƏLIŞ HUB (Analitik Təhlil + İdarəetmə proqramları) ───────────────

function YukselishHub({ user, onAuth, onHome, onDashboard, onNav, onAnalitik, onIdareetme }) {
  const cards = [
    {
      key: 'analitik',
      title: 'Analitik Təhlil',
      desc: 'Verbal, Rəqəmsal və Abstrakt Təhlil üzrə peşəkar hazırlıq',
      icon: 'analitik',
      action: onAnalitik,
      cta: 'Hazırlığa başla →',
      stats: [['3', 'Bölmə'], ['9', 'Test'], ['240', 'Sual']],
    },
    {
      key: 'idareetme',
      title: 'İdarəetmə Bacarıqları',
      desc: 'Situasiya Mühakiməsi və Emosional Zəka üzrə hazırlıq',
      icon: 'idareetme',
      action: onIdareetme,
      cta: 'Hazırlığa başla →',
      stats: [['21', 'Dərs'], ['6', 'Test'], ['486', 'Sual']],
    },
    {
      key: 'keysler',
      title: 'Qrup məşqləri və keyslər',
      desc: 'Qrup formatında praktiki məşqlər və keys həlli',
      icon: 'keysler',
      muted: true,
    },
  ]

  return (
    <div className="landing">
      <SiteNav
        user={user}
        onLogo={onHome}
        onNav={onNav}
        onAuth={onAuth}
        onDashboard={onDashboard}
        currentPage={PAGES.YUKSELISH_HUB}
      />

      <div style={{padding:'11px 28px', background:'#f9fbff', borderBottom:'1px solid #e5e7eb', fontSize:'13px', color:'#6b7280'}}>
        <span style={{cursor:'pointer', color:'#0a74da', fontWeight:500}} onClick={onHome}>← Ana səhifə</span>
        <span style={{margin:'0 8px', color:'#d1d5db'}}>/</span>
        <span style={{color:'#0c1f4a', fontWeight:600}}>Yüksəliş</span>
      </div>

      <div className="hero" style={{paddingBottom:'40px'}}>
        <h1 className="hero-tagline">Yüksəliş müsabiqəsinə<br/><span style={{color:'#0a74da'}}>hazırlıq</span></h1>
        <p className="hero-desc" style={{maxWidth:'560px'}}>
          Hər mərhələ üçün ayrıca hazırlıq materialı · Mərhələni seçin və başlayın
        </p>
      </div>

      <div className="topics-section" style={{paddingTop:'40px', paddingBottom:'72px'}}>
        <div className="pricing-grid" style={{maxWidth:'880px', margin:'0 auto'}}>
          {cards.map(c => (
            <div
              key={c.key}
              onClick={c.muted ? undefined : c.action}
              style={{
                background: c.muted ? '#f9fbff' : '#f0f7ff',
                border: c.muted ? '2px dashed #d1d5db' : '2px solid #0a74da',
                borderRadius:'14px',
                padding:'28px 22px', textAlign:'center',
                cursor: c.muted ? 'default' : 'pointer',
                display:'flex', flexDirection:'column', justifyContent:'flex-start',
                minHeight:'340px', height:'100%',
                transition:'transform 0.15s, box-shadow 0.15s',
              }}
              onMouseEnter={(e) => { if (!c.muted) e.currentTarget.style.transform = 'translateY(-2px)' }}
              onMouseLeave={(e) => { if (!c.muted) e.currentTarget.style.transform = 'translateY(0)' }}
            >
              <div style={{
                width:'60px', height:'60px', borderRadius:'14px',
                background: c.muted ? '#9ca3af' : '#0a74da',
                margin:'0 auto 16px', display:'flex', alignItems:'center', justifyContent:'center',
              }}>
                <TopicIcon name={c.icon} size={32} />
              </div>
              <div style={{fontSize:'22px', fontWeight:700, color:'#0c1f4a', marginBottom:'10px'}}>{c.title}</div>
              <div style={{fontSize:'15px', color:'#4b5563', lineHeight:1.55, marginBottom:'20px', minHeight:'48px'}}>{c.desc}</div>
              <div style={{flex:1}}></div>
              {c.muted ? (
                <div style={{
                  width:'100%', padding:'13px', fontSize:'15px', fontWeight:600,
                  color:'#6b7280', background:'#f1f3f5', borderRadius:'10px',
                }}>Tezliklə</div>
              ) : (
                <button
                  className="btn-primary"
                  style={{width:'100%', padding:'13px', fontSize:'16px', fontWeight:600}}
                  onClick={(e) => { e.stopPropagation(); c.action() }}
                >{c.cta}</button>
              )}
              {!c.muted && (
                <div style={{display:'flex', gap:'10px', borderTop:'1px solid #d1e4f7', marginTop:'18px', paddingTop:'18px'}}>
                  {c.stats.map(([num, label]) => (
                    <div key={label} style={{flex:1, textAlign:'center'}}>
                      <div style={{fontSize:'24px', fontWeight:700, color:'#0958a8'}}>{num}</div>
                      <div style={{fontSize:'13px', color:'#6b7280', marginTop:'2px'}}>{label}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

// ─── İDARƏETMƏ BACARIQLARI PAGE (SMT + EZ + bundle) ──────────────────────

function IdareetmePage({ user, purchases, hasPurchased, onBuy, onCourse, onAuth, onHome, onDashboard, onNav, onBack, onLesson }) {
  const ownsBundle = (purchases || []).includes('idareetme')
  const courses = [
    { slug:'smt', name:'Situasiya Mühakiməsi', icon:'smt',
      sub:'İdarəetmə situasiyalarında düzgün qərarvermə bacarığı', meta:'12 dərs · 3 test · 252 sual', price:'₼49' },
    { slug:'ez', name:'Emosional Zəka', icon:'ez',
      sub:'Emosiyaları qavrama, anlama və idarə etmə bacarığı', meta:'9 dərs · 3 test · 234 sual', price:'₼49' },
  ]
  return (
    <div className="landing">
      <SiteNav user={user} onLogo={onHome} onNav={onNav} onAuth={onAuth}
        onDashboard={onDashboard} currentPage={PAGES.YUKSELISH_IDAREETME} />

      <div style={{padding:'11px 28px', background:'#f9fbff', borderBottom:'1px solid #e5e7eb', fontSize:'13px', color:'#6b7280'}}>
        <span style={{cursor:'pointer', color:'#0a74da', fontWeight:500}} onClick={onHome}>← Ana səhifə</span>
        <span style={{margin:'0 8px', color:'#d1d5db'}}>/</span>
        <span style={{cursor:'pointer', color:'#0a74da', fontWeight:500}} onClick={onBack}>Yüksəliş</span>
        <span style={{margin:'0 8px', color:'#d1d5db'}}>/</span>
        <span style={{color:'#0c1f4a', fontWeight:600}}>İdarəetmə Bacarıqları</span>
      </div>

      <div className="hero" style={{paddingBottom:'56px'}}>
        <div style={{fontSize:'13px', fontWeight:700, color:'#0a74da', letterSpacing:'2px', textTransform:'uppercase', marginBottom:'18px'}}>YÜKSƏLIŞ MÜSABIQƏSI</div>
        <h1 className="hero-tagline">İdarəetmə Bacarıqları<br/>imtahanına hazırlıq</h1>
        <p className="hero-desc" style={{maxWidth:'580px'}}>
          Situasiya Mühakiməsi və Emosional Zəka üzrə peşəkar hazırlıq · Dərslər və testlər · Detallı izahlar
        </p>
        <div className="hero-btns">
          <button className="btn-primary btn-lg" onClick={() => onLesson('smt', 1)}>Ödənişsiz başla</button>
        </div>
      </div>

      <div className="topics-section" style={{paddingTop:'24px', paddingBottom:'72px'}}>
        <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(240px, 1fr))', gap:'18px', maxWidth:'820px', margin:'0 auto'}}>
          {courses.map(c => {
            const owned = hasPurchased(c.slug)
            return (
              <div key={c.slug} className="price-card" style={{display:'flex', flexDirection:'column'}}>
                <TopicIcon name={c.icon} size={40} />
                <div className="price-name">{c.name}</div>
                <div style={{fontSize:'13px', color:'#6b7280', lineHeight:1.55, marginBottom:'14px', minHeight:'58px'}}>{c.sub}</div>
                <div className="price-amount">
                  {owned
                    ? <span style={{display:'inline-block', padding:'4px 14px', background:'white', color:'#16a34a', border:'1.5px solid #16a34a', fontSize:'13px', fontWeight:600, borderRadius:'20px'}}>✓ Aktivdir</span>
                    : c.price}
                </div>
                <div className="price-desc">{c.meta}</div>
                <div style={{flex:1}}></div>
                {owned
                  ? <button className="btn-primary btn-full" onClick={() => onCourse(c.slug)}>Davam et →</button>
                  : <>
                      <button className="btn-outline btn-full" style={{marginBottom:8}} onClick={() => onBuy(c.slug)}>Satın al</button>
                      <button className="btn-ghost-sm btn-full" onClick={() => onCourse(c.slug)}>Dərslərə bax →</button>
                    </>}
              </div>
            )
          })}

          <div className="price-card featured" style={{display:'flex', flexDirection:'column'}}>
            {!ownsBundle && <div className="save-badge" style={{fontSize:'13px', padding:'5px 14px'}}>39 ₼ qənaət</div>}
            <TopicIcon name="idareetme" size={40} />
            <div className="price-name">İdarəetmə Bacarıqları</div>
            <div style={{fontSize:'13px', color:'#6b7280', lineHeight:1.55, marginBottom:'14px', minHeight:'58px'}}>Situasiya Mühakiməsi + Emosional Zəka · Ən sərfəli seçim</div>
            <div className="price-amount">
              {ownsBundle
                ? <span style={{display:'inline-block', padding:'4px 14px', background:'white', color:'#16a34a', border:'1.5px solid #16a34a', fontSize:'13px', fontWeight:600, borderRadius:'20px'}}>✓ Aktivdir</span>
                : '₼59'}
            </div>
            <div className="price-desc">21 dərs · 6 test · 486 sual</div>
            <div style={{flex:1}}></div>
            {ownsBundle
              ? <button className="btn-primary btn-full" onClick={() => onCourse('smt')}>Davam et →</button>
              : <button className="btn-primary btn-full" onClick={() => onBuy('idareetme')}>İndi al</button>}
          </div>
        </div>
      </div>
    </div>
  )
}

// ─── COURSE PAGE (lists lessons for one course) ───────────────────────────

function CoursePage({ user, courseSlug, purchases, hasPurchased, onBuy, onMock, onAuth, onHome, onDashboard, onNav, onBack, onLesson, onCourse }) {
  const [course, setCourse] = useState(null)
  const [lessons, setLessons] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const COURSE_NAMES = { smt: 'Situasiya Mühakimə Testləri', ez: 'Emosional Zəka' }
  const courseName = course?.title || COURSE_NAMES[courseSlug] || ''

  useEffect(() => {
    let active = true
    setLoading(true); setError('')
    ;(async () => {
      try {
        const { data: courseRow } = await supabase
          .from('courses').select('*').eq('slug', courseSlug).maybeSingle()
        const { data: lessonRows, error: lerr } = await supabase
          .from('lessons').select('*').eq('course', courseSlug).order('lesson_number', { ascending: true })
        if (lerr) throw lerr
        if (!active) return
        setCourse(courseRow || null)
        setLessons(lessonRows || [])
      } catch (err) {
        if (active) setError('Məlumat yüklənmədi. Yenidən cəhd edin.')
      }
      if (active) setLoading(false)
    })()
    return () => { active = false }
  }, [courseSlug])

  return (
    <div className="landing">
      <SiteNav
        user={user}
        onLogo={onHome}
        onNav={onNav}
        onAuth={onAuth}
        onDashboard={onDashboard}
        currentPage={PAGES.COURSE}
      />

      <div style={{padding:'11px 28px', background:'#f9fbff', borderBottom:'1px solid #e5e7eb', fontSize:'13px', color:'#6b7280'}}>
        <span style={{cursor:'pointer', color:'#0a74da', fontWeight:500}} onClick={onBack}>← İdarəetmə Bacarıqları</span>
        <span style={{margin:'0 8px', color:'#d1d5db'}}>/</span>
        <span style={{color:'#0c1f4a', fontWeight:600}}>{courseName}</span>
      </div>

      <div style={{display:'flex', gap:'8px', maxWidth:'720px', margin:'0 auto', padding:'16px 24px 0', boxSizing:'border-box'}}>
        {[{slug:'smt', name:'Situasiya Mühakiməsi'}, {slug:'ez', name:'Emosional Zəka'}].map(c => {
          const active = c.slug === courseSlug
          return (
            <button key={c.slug} onClick={() => { if (!active && onCourse) onCourse(c.slug) }}
              style={{
                flex:1, padding:'10px 14px', fontSize:'14px', fontWeight:600,
                cursor: active ? 'default' : 'pointer', borderRadius:'10px', fontFamily:'inherit',
                background: active ? '#0a74da' : 'white',
                color: active ? 'white' : '#0a74da',
                border:'1.5px solid #0a74da',
              }}>{c.name}</button>
          )
        })}
      </div>

      <div style={{maxWidth:'720px', margin:'0 auto', padding:'40px 24px 80px'}}>
        {loading && <div style={{textAlign:'center', color:'#6b7280', padding:'40px 0'}}>Yüklənir...</div>}
        {error && <div style={{textAlign:'center', color:'#dc2626', padding:'40px 0'}}>{error}</div>}

        {!loading && !error && (() => { const owns = hasPurchased && hasPurchased(courseSlug); return (
          <>
            <h1 style={{fontSize:'30px', fontWeight:700, color:'#0c1f4a', letterSpacing:'-0.5px', marginBottom:'10px'}}>
              {courseName}
            </h1>
            {course?.description && (
              <p style={{fontSize:'15px', color:'#4b5563', lineHeight:1.65, marginBottom:'28px'}}>{course.description}</p>
            )}

            {owns && (
              <div style={{display:'inline-block', marginBottom:'20px', fontSize:'13px', fontWeight:700, color:'#16a34a', background:'#f0fdf4', border:'1.5px solid #bbf7d0', padding:'6px 16px', borderRadius:'20px'}}>
                ✓ Tam girişiniz var
              </div>
            )}

            <h2 style={{fontSize:'15px', fontWeight:700, color:'#6b7280', letterSpacing:'1px', textTransform:'uppercase', marginBottom:'14px'}}>
              Dərslər
            </h2>

            <div style={{display:'flex', flexDirection:'column', gap:'10px'}}>
              {lessons.map(lesson => {
                const unlocked = lesson.is_free || owns
                return (
                  <div
                    key={lesson.id}
                    onClick={() => unlocked ? onLesson(lesson) : onBuy(courseSlug)}
                    style={{
                      background:'white', border:'1.5px solid #d1e4f7', borderRadius:'12px',
                      padding:'16px 18px', display:'flex', alignItems:'center', gap:'14px',
                      cursor:'pointer',
                      opacity: unlocked ? 1 : 0.7,
                    }}
                  >
                    <div style={{
                      width:'30px', height:'30px', borderRadius:'50%',
                      background: unlocked ? '#e8f3ff' : '#f1f3f5', color: unlocked ? '#0a74da' : '#9ca3af',
                      display:'flex', alignItems:'center', justifyContent:'center',
                      fontSize:'14px', fontWeight:700, flexShrink:0,
                    }}>{lesson.lesson_number}</div>
                    <div style={{flex:1}}>
                      <div style={{fontSize:'15px', fontWeight:600, color:'#0c1f4a'}}>{lesson.title}</div>
                    </div>
                    {lesson.is_free && !owns
                      ? <span style={{fontSize:'12px', fontWeight:700, color:'#16a34a', background:'#f0fdf4', border:'1px solid #bbf7d0', padding:'4px 12px', borderRadius:'20px'}}>Ödənişsiz</span>
                      : unlocked
                        ? <span style={{fontSize:'13px', color:'#0a74da', fontWeight:600}}>Dərsə başla →</span>
                        : <span style={{fontSize:'13px', color:'#9ca3af'}}>🔒</span>}
                  </div>
                )
              })}
              {lessons.length === 0 && (
                <div style={{textAlign:'center', color:'#6b7280', padding:'24px 0'}}>Dərslər tezliklə əlavə olunacaq.</div>
              )}
            </div>

            <h2 style={{fontSize:'15px', fontWeight:700, color:'#6b7280', letterSpacing:'1px', textTransform:'uppercase', margin:'32px 0 14px'}}>
              Testlər
            </h2>
            <div style={{display:'flex', flexDirection:'column', gap:'10px'}}>
              {[1, 2, 3].map(mn => {
                const mockReady = MOCK_TESTS.some(q => q.course === courseSlug && q.mock_num === mn)
                return (
                  <div
                    key={mn}
                    onClick={() => mockReady ? (owns ? onMock(courseSlug, mn) : onBuy(courseSlug)) : null}
                    style={{
                      background:'white', border:'1.5px solid #d1e4f7', borderRadius:'12px',
                      padding:'16px 18px', display:'flex', alignItems:'center', gap:'14px',
                      cursor: mockReady ? 'pointer' : 'default', opacity: mockReady ? (owns ? 1 : 0.7) : 0.6,
                    }}
                  >
                    <div style={{
                      width:'30px', height:'30px', borderRadius:'50%',
                      background: (mockReady && owns) ? '#e8f3ff' : '#f1f3f5',
                      color: (mockReady && owns) ? '#0a74da' : '#9ca3af',
                      display:'flex', alignItems:'center', justifyContent:'center',
                      fontSize:'13px', fontWeight:700, flexShrink:0,
                    }}>S{mn}</div>
                    <div style={{flex:1}}>
                      <div style={{fontSize:'15px', fontWeight:600, color:'#0c1f4a'}}>Test {mn}</div>
                      <div style={{fontSize:'12px', color:'#6b7280'}}>Tam imtahan formatında · bütün bacarıqlar</div>
                    </div>
                    {!mockReady
                      ? <span style={{fontSize:'12px', color:'#9ca3af'}}>Tezliklə</span>
                      : owns
                        ? <span style={{fontSize:'13px', color:'#0a74da', fontWeight:600}}>Testə başla →</span>
                        : <span style={{fontSize:'13px', color:'#9ca3af'}}>🔒</span>}
                  </div>
                )
              })}
            </div>

            {!owns && (
              <div style={{
                marginTop:'24px', background:'#f0f7ff', border:'2px solid #0a74da',
                borderRadius:'14px', padding:'20px 22px',
              }}>
                <div style={{
                  display:'flex', alignItems:'center', justifyContent:'space-between',
                  gap:'16px', flexWrap:'wrap',
                }}>
                  <div>
                    <div style={{fontSize:'16px', fontWeight:700, color:'#0c1f4a', marginBottom:'3px'}}>
                      Bu proqrama tam giriş
                    </div>
                    <div style={{fontSize:'13px', color:'#4b5563'}}>
                      Bütün dərslər və testlər
                    </div>
                  </div>
                  <button
                    className="btn-outline"
                    style={{padding:'11px 22px', fontSize:'14px', fontWeight:600, whiteSpace:'nowrap'}}
                    onClick={() => onBuy(courseSlug)}
                  >
                    Satın al · ₼49
                  </button>
                </div>

                <div style={{borderTop:'1px solid #cfe3fa', margin:'16px 0 0', paddingTop:'16px',
                  display:'flex', alignItems:'center', justifyContent:'space-between',
                  gap:'16px', flexWrap:'wrap'}}>
                  <div>
                    <div style={{fontSize:'15px', fontWeight:700, color:'#0c1f4a', marginBottom:'3px'}}>
                      Hər iki proqram lazımdır?
                    </div>
                    <div style={{fontSize:'13px', color:'#4b5563'}}>
                      İdarəetmə Bacarıqları paketi: Situasiya Mühakiməsi + Emosional Zəka, ₼39 qənaət
                    </div>
                  </div>
                  <button
                    className="btn-primary"
                    style={{padding:'12px 24px', fontSize:'15px', fontWeight:600, whiteSpace:'nowrap'}}
                    onClick={() => onBuy('idareetme')}
                  >
                    Paketi al · ₼59
                  </button>
                </div>
              </div>
            )}
          </>
        ) })()}
      </div>
    </div>
  )
}

// ─── LESSON PAGE (lesson text + quiz button) ──────────────────────────────

function LessonPage({ user, lesson, hasPurchased, onBuy, onAuth, onHome, onDashboard, onNav, onBack, onQuiz, onLesson }) {
  const [siblings, setSiblings] = useState([])
  useEffect(() => {
    let active = true
    ;(async () => {
      try {
        const { data } = await supabase.from('lessons').select('*')
          .eq('course', lesson.course).order('lesson_number', { ascending: true })
        if (active) setSiblings(data || [])
      } catch { if (active) setSiblings([]) }
    })()
    return () => { active = false }
  }, [lesson.course])

  const owns = hasPurchased ? hasPurchased(lesson.course) : false
  const unlocked = lesson.is_free || owns
  const idx = siblings.findIndex(l => l.lesson_number === lesson.lesson_number)
  const prev = idx > 0 ? siblings[idx - 1] : null
  const next = idx >= 0 && idx < siblings.length - 1 ? siblings[idx + 1] : null
  const total = siblings.length || null
  const courseNames = { smt: 'Situasiya Mühakiməsi', ez: 'Emosional Zəka' }
  const isMobile = useIsMobile()
  const [listOpen, setListOpen] = useState(false)

  const NavRow = ({ bottom }) => (
    <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', gap:'12px', margin: bottom ? '40px 0 0' : '0 0 8px'}}>
      <button onClick={() => prev && onLesson(prev)} disabled={!prev} className="btn-outline"
        style={{padding:'10px 16px', fontSize:'14px', fontWeight:600, opacity: prev ? 1 : 0.4, cursor: prev ? 'pointer' : 'default'}}>← Əvvəlki</button>
      {total && <span style={{fontSize:'13px', color:'#6b7280', fontWeight:600}}>Dərs {lesson.lesson_number} / {total}</span>}
      <button onClick={() => next && onLesson(next)} disabled={!next} className="btn-outline"
        style={{padding:'10px 16px', fontSize:'14px', fontWeight:600, opacity: next ? 1 : 0.4, cursor: next ? 'pointer' : 'default'}}>
        {next && !(next.is_free || owns) ? 'Sonrakı 🔒' : 'Sonrakı →'}</button>
    </div>
  )

  const LessonList = ({ onPick }) => (
    <div style={{background:'white', border:'1.5px solid #d1e4f7', borderRadius:'12px', overflow:'hidden'}}>
      <div style={{padding:'12px 16px', borderBottom:'1px solid #eef2f7', fontSize:'12px', fontWeight:700, color:'#6b7280', letterSpacing:'1px', textTransform:'uppercase'}}>
        Dərslər
      </div>
      {siblings.map(l => {
        const isCur = l.lesson_number === lesson.lesson_number
        const lUnlocked = l.is_free || owns
        return (
          <div key={l.id}
            onClick={() => { if (isCur) return; if (lUnlocked) onLesson(l); else onBuy(lesson.course); if (onPick) onPick() }}
            style={{display:'flex', alignItems:'center', gap:'10px', padding:'10px 14px',
              cursor: isCur ? 'default' : 'pointer',
              background: isCur ? '#eaf3ff' : 'white',
              borderLeft: isCur ? '3px solid #0a74da' : '3px solid transparent'}}>
            <span style={{width:'22px', height:'22px', borderRadius:'50%', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'12px', fontWeight:700,
              background: isCur ? '#0a74da' : (lUnlocked ? '#e8f3ff' : '#f1f3f5'),
              color: isCur ? 'white' : (lUnlocked ? '#0a74da' : '#9ca3af')}}>{l.lesson_number}</span>
            <span style={{flex:1, fontSize:'13px', fontWeight: isCur ? 700 : 500, lineHeight:1.4,
              color: isCur ? '#0c1f4a' : (lUnlocked ? '#374151' : '#9ca3af')}}>{l.title}</span>
            {!lUnlocked && <span style={{fontSize:'12px'}}>🔒</span>}
          </div>
        )
      })}
    </div>
  )

  const mainContent = (
    <>
      <NavRow />
      <div style={{fontSize:'13px', fontWeight:700, color:'#0a74da', letterSpacing:'1px', textTransform:'uppercase', margin:'18px 0 8px'}}>
        Dərs {lesson.lesson_number}
      </div>
      <h1 style={{fontSize:'30px', fontWeight:700, color:'#0c1f4a', letterSpacing:'-0.5px', marginBottom:'24px'}}>
        {lesson.title}
      </h1>

      {unlocked ? (
        <>
          <Markdown text={lesson.body} />

          <div style={{
            marginTop:'36px', background:'#f0f7ff', border:'1.5px solid #0a74da',
            borderRadius:'14px', padding:'22px 24px', display:'flex',
            alignItems:'center', justifyContent:'space-between', gap:'16px', flexWrap:'wrap',
          }}>
            <div>
              <div style={{fontSize:'16px', fontWeight:700, color:'#0c1f4a', marginBottom:'3px'}}>Quiz {lesson.lesson_number}</div>
              <div style={{fontSize:'13px', color:'#6b7280'}}>Biliyinizi möhkəmləndirin</div>
            </div>
            <button className="btn-primary" style={{padding:'12px 22px', fontSize:'15px', fontWeight:600}}
              onClick={() => onQuiz(lesson.course, lesson.lesson_number)}>
              Quizə başla →
            </button>
          </div>

          {next && (next.is_free || owns) && (
            <div style={{marginTop:'16px', textAlign:'center'}}>
              <button className="btn-ghost" style={{fontSize:'14px', fontWeight:600, color:'#0a74da'}} onClick={() => onLesson(next)}>
                Növbəti dərs: {next.title} →
              </button>
            </div>
          )}

          <NavRow bottom />
        </>
      ) : (
        <div style={{background:'#f0f7ff', border:'2px solid #0a74da', borderRadius:'14px', padding:'32px 24px', textAlign:'center', marginTop:'8px'}}>
          <div style={{fontSize:'34px', marginBottom:'8px'}}>🔒</div>
          <div style={{fontSize:'18px', fontWeight:700, color:'#0c1f4a', marginBottom:'6px'}}>Bu dərs ödənişli paketə daxildir</div>
          <p style={{fontSize:'14px', color:'#4b5563', marginBottom:'18px', lineHeight:1.6}}>
            İlk dərs ödənişsizdir. Bu dərsə və növbəti materiallara davam etmək üçün proqramı əldə edin.
          </p>
          <div style={{maxWidth:'360px', margin:'0 auto', display:'flex', flexDirection:'column', gap:'10px'}}>
            <button className="btn-primary btn-lg" style={{width:'100%'}} onClick={() => onBuy('idareetme')}>Tam paket: SMT + EZT · ₼59</button>
            <button className="btn-outline" style={{width:'100%', padding:'12px'}} onClick={() => onBuy(lesson.course)}>Yalnız {lesson.course === 'ez' ? 'EZT' : 'SMT'} · ₼49</button>
          </div>
        </div>
      )}
    </>
  )

  return (
    <div className="landing">
      <SiteNav user={user} onLogo={onHome} onNav={onNav} onAuth={onAuth} onDashboard={onDashboard} currentPage={PAGES.LESSON} />

      <div style={{padding:'11px 28px', background:'#f9fbff', borderBottom:'1px solid #e5e7eb', fontSize:'13px', color:'#6b7280'}}>
        <span style={{cursor:'pointer', color:'#0a74da', fontWeight:500}} onClick={onBack}>← {courseNames[lesson.course] || 'Dərslər'}</span>
        <span style={{margin:'0 8px', color:'#d1d5db'}}>/</span>
        <span style={{color:'#0c1f4a', fontWeight:600}}>Dərs {lesson.lesson_number}</span>
      </div>

      {isMobile ? (
        <div style={{maxWidth:'720px', margin:'0 auto', padding:'20px 24px 80px'}}>
          <button onClick={() => setListOpen(o => !o)} className="btn-outline"
            style={{width:'100%', padding:'11px 14px', fontSize:'14px', fontWeight:600, marginBottom: listOpen ? '12px' : '18px', display:'flex', justifyContent:'space-between', alignItems:'center'}}>
            <span>Bütün dərslər ({total || siblings.length})</span><span>{listOpen ? '▲' : '▼'}</span>
          </button>
          {listOpen && <div style={{marginBottom:'20px'}}><LessonList onPick={() => setListOpen(false)} /></div>}
          {mainContent}
        </div>
      ) : (
        <div style={{maxWidth:'1040px', margin:'0 auto', padding:'28px 24px 80px', display:'flex', gap:'28px', alignItems:'flex-start'}}>
          <div style={{flex:1, minWidth:0, maxWidth:'700px'}}>
            {mainContent}
          </div>
          <aside style={{width:'250px', flexShrink:0, position:'sticky', top:'20px'}}>
            <LessonList />
          </aside>
        </div>
      )}
    </div>
  )
}